[
  {
    "id": "goes_u",
    "label": "GOES-U / GOES-19",
    "missionIds": [
      "goes19"
    ],
    "noradIds": [
      "60133"
    ],
    "spanM": 17,
    "sources": [
      "https://science.nasa.gov/mission/goes-spacecraft-3d-model/"
    ],
    "pattern": "^GOES[- ]?(19|U)\\b",
    "kind": "reconstruction",
    "note": "Source-informed exterior reconstruction. Existing detailed GOES-R exterior adapted with a separate reconstructed CCOR-1 housing. Coronagraph placement and dimensions are approximate; not GOES-U flight CAD. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_goes_u",
    "modelUrl": "/models/spacecraft/goes_u.glb",
    "metersPerUnit": 1,
    "boundsM": [
      17,
      14.0538,
      9.5591
    ],
    "parts": [
      "part_array_support",
      "part_power",
      "part_suvi_exis_platform",
      "part_deployable_boom",
      "part_abi",
      "part_glm",
      "part_inertial_unit",
      "part_source_structure",
      "part_source_structure_1",
      "part_radiator",
      "part_source_structure_2",
      "part_source_structure_3",
      "part_star_trackers",
      "part_source_structure_4",
      "part_source_structure_5",
      "part_source_structure_6",
      "part_source_structure_7",
      "part_source_structure_8",
      "part_source_structure_9",
      "part_source_instrument_1",
      "part_source_instrument_3",
      "part_source_structure_10",
      "part_source_structure_11",
      "part_source_structure_12",
      "part_source_structure_13",
      "part_source_structure_14",
      "part_source_structure_15",
      "part_source_structure_16",
      "part_source_structure_17",
      "part_source_structure_18",
      "part_source_structure_19",
      "part_seiss",
      "part_thruster",
      "part_thruster_1",
      "part_star_trackers_1",
      "ccor1_housing"
    ],
    "provenance": {
      "source": "https://science.nasa.gov/mission/goes-spacecraft-3d-model/",
      "credit": "Existing ERT GOES-R reference plus original CCOR-1 housing reconstruction",
      "sourceSha256": "595838f79d7ae888c4e59bb26815f2c513a308ec4dfa5a47ddb27108a8ce9faf",
      "usage": "Existing project model adapted for the GOES-U reference; coronagraph position and housing are approximate"
    },
    "sha256": "4f447b283767fbc476a3e735ae94423160910c955e4c50ad91d43f5f8bb38bcb",
    "bytes": 691524
  },
  {
    "id": "jpss1",
    "label": "NOAA-20 / JPSS-1",
    "missionIds": [
      "noaa20"
    ],
    "noradIds": [
      "43013"
    ],
    "spanM": 9,
    "sources": [
      "https://www.ncei.noaa.gov/news/jpss-1-new-satellite-even-better-data"
    ],
    "pattern": "^(NOAA[- ]?20|JPSS[- ]?1)\\b",
    "kind": "reconstruction",
    "note": "Source-informed exterior reconstruction. JPSS-1 exterior reconstructed separately from S-NPP and JPSS-2, including the five published instrument suites. Housing geometry and scale approximate. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_jpss1",
    "modelUrl": "/models/spacecraft/jpss1.glb",
    "metersPerUnit": 1,
    "boundsM": [
      9,
      5.2993,
      3.0276
    ],
    "parts": [
      "spacecraft_bus",
      "solar_array",
      "viirs_housing",
      "cris_housing",
      "atms_housing",
      "omps_housing",
      "ceres_housing",
      "communications"
    ],
    "provenance": {
      "source": "https://www.ncei.noaa.gov/news/jpss-1-new-satellite-even-better-data",
      "credit": "Original Entarian exterior reconstruction from public mission references",
      "usage": "Original geometry; linked photographs are references and are not redistributed in the model"
    },
    "sha256": "fb2385c03694608ec01f1e1d9179c49ea6a46c1fa0f8c8e679ea24853e1c5766",
    "bytes": 81176
  },
  {
    "id": "solar1",
    "label": "SOLAR-1 / SWFO-L1",
    "missionIds": [
      "solar1"
    ],
    "noradIds": [],
    "spanM": 9,
    "sources": [
      "https://www.ncei.noaa.gov/products/space-weather/swfo"
    ],
    "pattern": "^(SOLAR[- ]?1|SWFO)",
    "kind": "reconstruction",
    "note": "Source-informed exterior reconstruction. Exterior reconstruction: CCOR-2, SWiPS, STIS and extended MAG boom. Approximate placement and scale; no L1 ephemeris connected. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_solar1",
    "modelUrl": "/models/spacecraft/solar1.glb",
    "metersPerUnit": 1,
    "boundsM": [
      9,
      2.6438,
      1.6063
    ],
    "parts": [
      "spacecraft_bus",
      "solar_array",
      "magnetometer_boom",
      "ccor2",
      "plasma_and_ion_sensors",
      "communications"
    ],
    "provenance": {
      "source": "https://www.ncei.noaa.gov/products/space-weather/swfo",
      "credit": "Original Entarian exterior reconstruction from public mission references",
      "usage": "Original geometry; linked photographs are references and are not redistributed in the model"
    },
    "sha256": "fb1d33319a07a2c1df77fd30c73f3eb8723d5d8e679487b25d2d758afc408c7b",
    "bytes": 79292
  },
  {
    "id": "dmsp5d3",
    "label": "DMSP Block 5D-3",
    "missionIds": [
      "dmsp_f16",
      "dmsp_f17",
      "dmsp_f18",
      "dmsp_f19"
    ],
    "noradIds": [
      "28054",
      "29522",
      "35951",
      "39630"
    ],
    "spanM": 8,
    "sources": [
      "https://www.losangeles.spaceforce.mil/Portals/16/documents/AFD-120802-071.pdf"
    ],
    "pattern": "^DMSP.*(F1[6-9]|5D-3)",
    "kind": "reconstruction",
    "note": "Source-informed exterior reconstruction. Block 5D-3 family exterior reconstruction with OLS and SSMIS. Shared approximate geometry; individual flight-unit differences are not represented. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_dmsp5d3",
    "modelUrl": "/models/spacecraft/dmsp5d3.glb",
    "metersPerUnit": 1,
    "boundsM": [
      8,
      3.7388,
      2.3764
    ],
    "parts": [
      "spacecraft_bus",
      "solar_array",
      "ols_housing",
      "ssmis_reflector",
      "space_environment_booms"
    ],
    "provenance": {
      "source": "https://www.losangeles.spaceforce.mil/Portals/16/documents/AFD-120802-071.pdf",
      "credit": "Original Entarian exterior reconstruction from public mission references",
      "usage": "Original geometry; linked photographs are references and are not redistributed in the model"
    },
    "sha256": "f171a89246ccd2e6a1432033b571a120813f5ca85f93d0da85408718db7ebe6d",
    "bytes": 41980
  },
  {
    "id": "goes_nop",
    "label": "GOES-N/O/P / EWS",
    "missionIds": [
      "ews_g2",
      "ews_g3"
    ],
    "noradIds": [
      "36411",
      "35491"
    ],
    "spanM": 13.5,
    "sources": [
      "https://www.ngdc.noaa.gov/stp/satellite/goes/doc/GOES_N_Series_Databook_rev-D.pdf"
    ],
    "pattern": "^(GOES[- ]?1[345]|EWS[- ]?G[123])\\b",
    "kind": "reconstruction",
    "note": "Source-informed exterior reconstruction. Boeing GOES-N/O/P family reconstruction, with one solar wing, solar sail and separate imager/sounder housings. Approximate dimensions. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_goes_nop",
    "modelUrl": "/models/spacecraft/goes_nop.glb",
    "metersPerUnit": 1,
    "boundsM": [
      13.5,
      4.4828,
      3.2977
    ],
    "parts": [
      "spacecraft_bus",
      "solar_array",
      "magnetometer_boom",
      "imager_housing",
      "sounder_housing",
      "solar_pointing_platform",
      "solar_sail",
      "communications"
    ],
    "provenance": {
      "source": "https://www.ngdc.noaa.gov/stp/satellite/goes/doc/GOES_N_Series_Databook_rev-D.pdf",
      "credit": "Original Entarian exterior reconstruction from public mission references",
      "usage": "Original geometry; linked photographs are references and are not redistributed in the model"
    },
    "sha256": "f08052b90e2c42c3e6ff291d6e151691500494e591417228ac4e0c0bbbef3590",
    "bytes": 91028
  },
  {
    "id": "cosmic2",
    "label": "COSMIC-2 / FORMOSAT-7",
    "missionIds": [
      "cosmic2_1",
      "cosmic2_2",
      "cosmic2_3",
      "cosmic2_4",
      "cosmic2_5",
      "cosmic2_6",
      "cosmic2"
    ],
    "noradIds": [
      "44349",
      "44351",
      "44343",
      "44350",
      "44358",
      "44353"
    ],
    "spanM": 3.5,
    "sources": [
      "https://www.nesdis.noaa.gov/current-satellite-missions/currently-flying/cosmic-2/cosmic-2-spacecraft"
    ],
    "pattern": "^(COSMIC[- ]?2|FORMOSAT[- ]?7)",
    "kind": "reconstruction",
    "note": "Source-informed exterior reconstruction. SSTL family exterior reconstruction with a single two-panel wing and radio-occultation antenna faces. All six flight identities share this approximate geometry. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_cosmic2",
    "modelUrl": "/models/spacecraft/cosmic2.glb",
    "metersPerUnit": 1,
    "boundsM": [
      3.5,
      2.1663,
      1.4128
    ],
    "parts": [
      "spacecraft_bus",
      "solar_array",
      "radio_occultation_antennas",
      "space_weather_sensors"
    ],
    "provenance": {
      "source": "https://www.nesdis.noaa.gov/current-satellite-missions/currently-flying/cosmic-2/cosmic-2-spacecraft",
      "credit": "Original Entarian exterior reconstruction from public mission references",
      "usage": "Original geometry; linked photographs are references and are not redistributed in the model"
    },
    "sha256": "e76b738a757329a482d1840eea9489c0aad9e26a12f75e239bf27334edd0c54d",
    "bytes": 40636
  },
  {
    "id": "gazelle",
    "label": "GAzelle / OTB-3 (Argos-4 host)",
    "missionIds": [
      "gazelle"
    ],
    "noradIds": [
      "54023"
    ],
    "spanM": 1.8,
    "sources": [
      "https://www.nesdis.noaa.gov/imagery/media-stills-animation/argos-4-instrument-gallery"
    ],
    "pattern": "^(GAZELLE|OTB[- ]?3)",
    "kind": "reconstruction",
    "note": "Source-informed exterior reconstruction. GAzelle exterior reconstructed from NOAA pre-ship photographs: body-mounted solar cells and Argos antenna assembly. Approximate dimensions; launch covers are omitted. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_gazelle",
    "modelUrl": "/models/spacecraft/gazelle.glb",
    "metersPerUnit": 1,
    "boundsM": [
      0.8392,
      1.8,
      0.8118
    ],
    "parts": [
      "spacecraft_bus",
      "body_solar_panels",
      "argos_antenna"
    ],
    "provenance": {
      "source": "https://www.nesdis.noaa.gov/imagery/media-stills-animation/argos-4-instrument-gallery",
      "credit": "Original Entarian exterior reconstruction from public mission references",
      "usage": "Original geometry; linked photographs are references and are not redistributed in the model"
    },
    "sha256": "761fd6fb715da57fca15e6c4ad80aec51ece9d9fb409d0b1a0e11d54e837f9c1",
    "bytes": 38560
  },
  {
    "id": "iss",
    "label": "International Space Station",
    "missionIds": [
      "iss",
      "tsis1",
      "sage3",
      "clarreo",
      "emit",
      "ecostress",
      "oco3",
      "gedi"
    ],
    "noradIds": [
      "25544"
    ],
    "spanM": 109,
    "sources": [
      "https://science.nasa.gov/mission/iss/"
    ],
    "kind": "official",
    "note": "NASA public visualization model, optimized for browser inspection. NASA IGOAL exterior reference, reduced for browser use. Source configuration includes named modules and external payloads; it is not a live docking/configuration record. ISS-hosted payload entries use the station as their host reference. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_iss",
    "modelUrl": "/models/spacecraft/iss.glb",
    "metersPerUnit": 1,
    "boundsM": [
      80.5287,
      33.3345,
      109
    ],
    "parts": [
      "habitable_modules",
      "external_payloads",
      "international_laboratories",
      "truss_and_structure",
      "thermal_control",
      "russian_segment",
      "solar_arrays",
      "robotics"
    ],
    "provenance": {
      "source": "https://github.com/nasa/NASA-3D-Resources/tree/11ebb4ee043715aefbba6aeec8a61746fad67fa7/3D%20Models/International%20Space%20Station%20(ISS)%20(D)%20(IGOAL)",
      "download": "https://raw.githubusercontent.com/nasa/NASA-3D-Resources/11ebb4ee043715aefbba6aeec8a61746fad67fa7/3D%20Models/International%20Space%20Station%20(ISS)%20(D)%20(IGOAL)/International%20Space%20Station%20(ISS).glb",
      "sourceSha256": "57cecfaf332efb2127d07796c4b65ca570d95a11516c8e046feb5a12efee491d",
      "credit": "NASA; source credits and model configuration retained in the linked source catalogue",
      "usage": "NASA media usage guidelines; no endorsement implied",
      "usageUrl": "https://www.nasa.gov/nasa-brand-center/images-and-media/"
    },
    "sha256": "b629c6b81142d11b8e602febb1554bcdad98fea842fa99cad4db9ef93132d990",
    "bytes": 7820560
  },
  {
    "id": "hubble",
    "label": "Hubble Space Telescope",
    "missionIds": [
      "hubble"
    ],
    "noradIds": [
      "20580"
    ],
    "spanM": 13.2,
    "sources": [
      "https://science.nasa.gov/mission/hubble/"
    ],
    "kind": "official",
    "note": "NASA public visualization model, optimized for browser inspection. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_hubble",
    "modelUrl": "/models/spacecraft/hubble.glb",
    "metersPerUnit": 1,
    "boundsM": [
      11.5112,
      13.2,
      12.5925
    ],
    "parts": [
      "exterior_structure"
    ],
    "provenance": {
      "source": "https://github.com/nasa/NASA-3D-Resources/tree/11ebb4ee043715aefbba6aeec8a61746fad67fa7/3D%20Models/Hubble%20Space%20Telescope%20(A)",
      "download": "https://raw.githubusercontent.com/nasa/NASA-3D-Resources/11ebb4ee043715aefbba6aeec8a61746fad67fa7/3D%20Models/Hubble%20Space%20Telescope%20(A)/Hubble%20Space%20Telescope%20(A).glb",
      "sourceSha256": "e5ba4de15c7d359ac8fa1ab7e286aff42dec09c0fadae3db99252587f39fa384",
      "credit": "NASA; source credits and model configuration retained in the linked source catalogue",
      "usage": "NASA media usage guidelines; no endorsement implied",
      "usageUrl": "https://www.nasa.gov/nasa-brand-center/images-and-media/"
    },
    "sha256": "53ecf5bacdaa0aca163efe2eb96a42fc625655957e42b73c411fcf3c32e3fc96",
    "bytes": 204644
  },
  {
    "id": "webb",
    "label": "James Webb Space Telescope",
    "missionIds": [
      "jwst"
    ],
    "noradIds": [],
    "spanM": 21.2,
    "sources": [
      "https://science.nasa.gov/mission/webb/"
    ],
    "kind": "official",
    "note": "NASA public visualization model, optimized for browser inspection. NASA variant B assembled exterior. Original geometry and materials retained without mesh simplification; combined exterior rather than separately inferred telescope subsystems. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "modelFile": "webb-assembled.glb",
    "template": "spacecraft_webb",
    "modelUrl": "/models/spacecraft/webb-assembled.glb",
    "metersPerUnit": 1,
    "boundsM": [
      12.9959,
      11.3662,
      21.2
    ],
    "parts": [
      "exterior_structure"
    ],
    "provenance": {
      "source": "https://github.com/nasa/NASA-3D-Resources/tree/11ebb4ee043715aefbba6aeec8a61746fad67fa7/3D%20Models/James%20Webb%20Space%20Telescope%20(B)",
      "download": "https://raw.githubusercontent.com/nasa/NASA-3D-Resources/11ebb4ee043715aefbba6aeec8a61746fad67fa7/3D%20Models/James%20Webb%20Space%20Telescope%20(B)/James%20Webb%20Space%20Telescope%20(B).glb",
      "sourceSha256": "4958e61e5a564f2efcc32cd516b9d36ea0b9bc644f64dbcfe182ce8a422ae526",
      "credit": "NASA; source credits and model configuration retained in the linked source catalogue",
      "usage": "NASA media usage guidelines; no endorsement implied",
      "usageUrl": "https://www.nasa.gov/nasa-brand-center/images-and-media/"
    },
    "sha256": "7a3fb6a2fa63a62e5839ac6972d0229b2344e1bc2ac1332c90702480ec1579ff",
    "bytes": 1374164
  },
  {
    "id": "aqua",
    "label": "Aqua",
    "missionIds": [
      "aqua"
    ],
    "noradIds": [
      "27424"
    ],
    "spanM": 16.7,
    "sources": [
      "https://science.nasa.gov/mission/aqua/"
    ],
    "kind": "official",
    "note": "NASA public visualization model, optimized for browser inspection. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_aqua",
    "modelUrl": "/models/spacecraft/aqua.glb",
    "metersPerUnit": 1,
    "boundsM": [
      4.7716,
      8.8311,
      16.7
    ],
    "parts": [
      "exterior_structure",
      "solar_arrays",
      "antenna_assemblies"
    ],
    "provenance": {
      "source": "https://github.com/nasa/NASA-3D-Resources/tree/11ebb4ee043715aefbba6aeec8a61746fad67fa7/3D%20Models/Aqua%20(A)",
      "download": "https://raw.githubusercontent.com/nasa/NASA-3D-Resources/11ebb4ee043715aefbba6aeec8a61746fad67fa7/3D%20Models/Aqua%20(A)/Aqua%20(A).glb",
      "sourceSha256": "5b5462b3947ae78e308ba9340d3c14cf13179a23006920b17e9e5ea142f3795a",
      "credit": "NASA; source credits and model configuration retained in the linked source catalogue",
      "usage": "NASA media usage guidelines; no endorsement implied",
      "usageUrl": "https://www.nasa.gov/nasa-brand-center/images-and-media/"
    },
    "sha256": "5e3626721692b4ca84badb67125c45fca6b373d8a5649369e5ea87ce1ad074dd",
    "bytes": 580444
  },
  {
    "id": "aura",
    "label": "Aura",
    "missionIds": [
      "aura"
    ],
    "noradIds": [
      "28376"
    ],
    "spanM": 15,
    "sources": [
      "https://science.nasa.gov/mission/aura/"
    ],
    "kind": "official",
    "note": "NASA public visualization model, optimized for browser inspection. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_aura",
    "modelUrl": "/models/spacecraft/aura.glb",
    "metersPerUnit": 1,
    "boundsM": [
      7.0053,
      15,
      2.7551
    ],
    "parts": [
      "exterior_structure"
    ],
    "provenance": {
      "source": "https://github.com/nasa/NASA-3D-Resources/tree/11ebb4ee043715aefbba6aeec8a61746fad67fa7/3D%20Models/Aura%20(B)",
      "download": "https://raw.githubusercontent.com/nasa/NASA-3D-Resources/11ebb4ee043715aefbba6aeec8a61746fad67fa7/3D%20Models/Aura%20(B)/Aura%20(B).glb",
      "sourceSha256": "819806ea72c7739c74545604b6a684531f0e0141af7ce08b1867a54ec392eaa2",
      "credit": "NASA; source credits and model configuration retained in the linked source catalogue",
      "usage": "NASA media usage guidelines; no endorsement implied",
      "usageUrl": "https://www.nasa.gov/nasa-brand-center/images-and-media/"
    },
    "sha256": "e536bbd1dc20079341bcbb1e3a0de460936917c0462992103326c90a6321a55f",
    "bytes": 828428
  },
  {
    "id": "terra",
    "label": "Terra",
    "missionIds": [
      "terra"
    ],
    "noradIds": [
      "25994"
    ],
    "spanM": 9,
    "sources": [
      "https://science.nasa.gov/mission/terra/"
    ],
    "kind": "official",
    "note": "NASA public visualization model, optimized for browser inspection. The NASA source omits two referenced image files; their surfaces use illustrative replacement materials. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_terra",
    "modelUrl": "/models/spacecraft/terra.glb",
    "metersPerUnit": 1,
    "boundsM": [
      4.7055,
      3.5498,
      9
    ],
    "parts": [
      "exterior_structure",
      "solar_arrays",
      "antenna_assemblies"
    ],
    "provenance": {
      "source": "https://github.com/nasa/NASA-3D-Resources/tree/11ebb4ee043715aefbba6aeec8a61746fad67fa7/3D%20Models/Terra",
      "download": "https://raw.githubusercontent.com/nasa/NASA-3D-Resources/11ebb4ee043715aefbba6aeec8a61746fad67fa7/3D%20Models/Terra/Terra.glb",
      "sourceSha256": "8794857595f7a7d416184fe926ecb50e11bf267dbe471d1cf2728a85e8d017fa",
      "credit": "NASA; source credits and model configuration retained in the linked source catalogue",
      "usage": "NASA media usage guidelines; no endorsement implied",
      "usageUrl": "https://www.nasa.gov/nasa-brand-center/images-and-media/"
    },
    "sha256": "3563f71c8bd7804bf458ab9366c8b10b08f53604b7de008fe446583be73de6a0",
    "bytes": 284896
  },
  {
    "id": "icesat2",
    "label": "ICESat-2",
    "missionIds": [
      "icesat2"
    ],
    "noradIds": [
      "43613"
    ],
    "spanM": 9.7,
    "sources": [
      "https://science.nasa.gov/mission/icesat2/"
    ],
    "kind": "official",
    "note": "NASA public visualization model, optimized for browser inspection. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_icesat2",
    "modelUrl": "/models/spacecraft/icesat2.glb",
    "metersPerUnit": 1,
    "boundsM": [
      4.7995,
      3.0584,
      9.7
    ],
    "parts": [
      "exterior_structure",
      "solar_arrays"
    ],
    "provenance": {
      "source": "https://github.com/nasa/NASA-3D-Resources/tree/11ebb4ee043715aefbba6aeec8a61746fad67fa7/3D%20Models/Ice%2C%20Clouds%2C%20and%20Land%20Elevation%20Satellite-2%20(ICESat-2)%20(B)",
      "download": "https://raw.githubusercontent.com/nasa/NASA-3D-Resources/11ebb4ee043715aefbba6aeec8a61746fad67fa7/3D%20Models/Ice%2C%20Clouds%2C%20and%20Land%20Elevation%20Satellite-2%20(ICESat-2)%20(B)/Ice%2C%20Clouds%2C%20and%20Land%20Elevation%20Satellite-2%20(ICESat-2)%20(B).glb",
      "sourceSha256": "40263edd49f772ab4827903fc7a76cbc4d67ef6fd7a572b6b9641f0e67c5be25",
      "credit": "NASA; source credits and model configuration retained in the linked source catalogue",
      "usage": "NASA media usage guidelines; no endorsement implied",
      "usageUrl": "https://www.nasa.gov/nasa-brand-center/images-and-media/"
    },
    "sha256": "06160bf70fc82f4d3f378ac2d582d6c4bf180917ca4e9a3d42d1b2a0a10d6851",
    "bytes": 310820
  },
  {
    "id": "gpm",
    "label": "GPM Core Observatory",
    "missionIds": [
      "gpm"
    ],
    "noradIds": [
      "39574"
    ],
    "spanM": 13,
    "sources": [
      "https://science.nasa.gov/mission/gpm/"
    ],
    "kind": "official",
    "note": "NASA public visualization model, optimized for browser inspection. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_gpm",
    "modelUrl": "/models/spacecraft/gpm.glb",
    "metersPerUnit": 1,
    "boundsM": [
      5.7075,
      8.0789,
      13
    ],
    "parts": [
      "exterior_structure"
    ],
    "provenance": {
      "source": "https://github.com/nasa/NASA-3D-Resources/tree/11ebb4ee043715aefbba6aeec8a61746fad67fa7/3D%20Models/Global%20Precipitation%20Measurement",
      "download": "https://raw.githubusercontent.com/nasa/NASA-3D-Resources/11ebb4ee043715aefbba6aeec8a61746fad67fa7/3D%20Models/Global%20Precipitation%20Measurement/Global%20Precipitation%20Measurement.glb",
      "sourceSha256": "7068c880770bb2ac936e804a1af48e564c90b829ff884c405a4759e8da9e693e",
      "credit": "NASA; source credits and model configuration retained in the linked source catalogue",
      "usage": "NASA media usage guidelines; no endorsement implied",
      "usageUrl": "https://www.nasa.gov/nasa-brand-center/images-and-media/"
    },
    "sha256": "d5efa02120b3aeb4b14266c450d3dc811e05a5fa1807593b805b6c24b6b3fab2",
    "bytes": 2455108
  },
  {
    "id": "sentinel6",
    "label": "Sentinel-6",
    "missionIds": [
      "sentinel6"
    ],
    "noradIds": [
      "46984"
    ],
    "spanM": 5.3,
    "sources": [
      "https://science.nasa.gov/mission/sentinel6/"
    ],
    "kind": "official",
    "note": "NASA public visualization model, optimized for browser inspection. Sentinel-6 family reference. Shared external configuration; not individual spacecraft attitude telemetry. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_sentinel6",
    "modelUrl": "/models/spacecraft/sentinel6.glb",
    "metersPerUnit": 1,
    "boundsM": [
      5.3,
      2.3994,
      4.514
    ],
    "parts": [
      "exterior_structure",
      "antenna_assemblies"
    ],
    "provenance": {
      "source": "https://github.com/nasa/NASA-3D-Resources/tree/11ebb4ee043715aefbba6aeec8a61746fad67fa7/3D%20Models/Jason%20Continuity%20of%20Service%20(Sentinel-6)",
      "download": "https://raw.githubusercontent.com/nasa/NASA-3D-Resources/11ebb4ee043715aefbba6aeec8a61746fad67fa7/3D%20Models/Jason%20Continuity%20of%20Service%20(Sentinel-6)/Jason%20Continuity%20of%20Service%20(Sentinel-6).glb",
      "sourceSha256": "cd257b8d63deef018d0227fa6c4bcb29974f257073c4d4f92abd557098b3d580",
      "credit": "NASA; source credits and model configuration retained in the linked source catalogue",
      "usage": "NASA media usage guidelines; no endorsement implied",
      "usageUrl": "https://www.nasa.gov/nasa-brand-center/images-and-media/"
    },
    "sha256": "feb7afbf9eedf7e84e675680fc25034fc65acb58d43ff971ca4af840a6ced278",
    "bytes": 485476
  },
  {
    "id": "cygnss",
    "label": "CYGNSS",
    "missionIds": [
      "cygnss"
    ],
    "noradIds": [],
    "spanM": 1.7,
    "sources": [
      "https://science.nasa.gov/mission/cygnss/"
    ],
    "kind": "official",
    "note": "NASA public visualization model, optimized for browser inspection. Shared CYGNSS spacecraft model; a mission row represents one member, not the full constellation. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_cygnss",
    "modelUrl": "/models/spacecraft/cygnss.glb",
    "metersPerUnit": 1,
    "boundsM": [
      1.7,
      0.5473,
      0.261
    ],
    "parts": [
      "exterior_structure",
      "antenna_assemblies",
      "solar_arrays"
    ],
    "provenance": {
      "source": "https://github.com/nasa/NASA-3D-Resources/tree/11ebb4ee043715aefbba6aeec8a61746fad67fa7/3D%20Models/Cyclone%20Global%20Navigation%20Satellite%20System%20(CYGNSS)",
      "download": "https://raw.githubusercontent.com/nasa/NASA-3D-Resources/11ebb4ee043715aefbba6aeec8a61746fad67fa7/3D%20Models/Cyclone%20Global%20Navigation%20Satellite%20System%20(CYGNSS)/Cyclone%20Global%20Navigation%20Satellite%20System%20(CYGNSS).glb",
      "sourceSha256": "830321f2d30099b4355f835d7ae5a2ab1f9f91c292dd01dfc008b8d4bf64c962",
      "credit": "NASA; source credits and model configuration retained in the linked source catalogue",
      "usage": "NASA media usage guidelines; no endorsement implied",
      "usageUrl": "https://www.nasa.gov/nasa-brand-center/images-and-media/"
    },
    "sha256": "a67a38d8a9776f867bafd10fcbaf0cf73250a3e9c4f9e43d979526ca35cba395",
    "bytes": 133868
  },
  {
    "id": "mro",
    "label": "Mars Reconnaissance Orbiter",
    "missionIds": [
      "mro"
    ],
    "noradIds": [],
    "spanM": 13.6,
    "sources": [
      "https://science.nasa.gov/mission/mro/"
    ],
    "kind": "official",
    "note": "NASA public visualization model, optimized for browser inspection. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_mro",
    "modelUrl": "/models/spacecraft/mro.glb",
    "metersPerUnit": 1,
    "boundsM": [
      4.9654,
      9.2454,
      13.6
    ],
    "parts": [
      "exterior_structure"
    ],
    "provenance": {
      "source": "https://github.com/nasa/NASA-3D-Resources/tree/11ebb4ee043715aefbba6aeec8a61746fad67fa7/3D%20Models/Mars%20Reconnaissance%20Orbiter%20(MRO)%20(A)",
      "download": "https://raw.githubusercontent.com/nasa/NASA-3D-Resources/11ebb4ee043715aefbba6aeec8a61746fad67fa7/3D%20Models/Mars%20Reconnaissance%20Orbiter%20(MRO)%20(A)/Mars%20Reconnaissance%20Orbiter%20(MRO)%20(A).glb",
      "sourceSha256": "b195c566d227dec8e42ca2fafcc2a8cc26a127e04ed577e4b9515199d2002d9e",
      "credit": "NASA; source credits and model configuration retained in the linked source catalogue",
      "usage": "NASA media usage guidelines; no endorsement implied",
      "usageUrl": "https://www.nasa.gov/nasa-brand-center/images-and-media/"
    },
    "sha256": "6b05492b6a47bb9465845df4e674991cf0c6a7e40a1a4da868b7b45e46b02870",
    "bytes": 1071148
  },
  {
    "id": "maven",
    "label": "MAVEN",
    "missionIds": [
      "maven"
    ],
    "noradIds": [],
    "spanM": 11.4,
    "sources": [
      "https://science.nasa.gov/mission/maven/"
    ],
    "kind": "official",
    "note": "NASA public visualization model, optimized for browser inspection. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_maven",
    "modelUrl": "/models/spacecraft/maven.glb",
    "metersPerUnit": 1,
    "boundsM": [
      11.4,
      6.5138,
      4.5473
    ],
    "parts": [
      "exterior_structure"
    ],
    "provenance": {
      "source": "https://github.com/nasa/NASA-3D-Resources/tree/11ebb4ee043715aefbba6aeec8a61746fad67fa7/3D%20Models/Mars%20Atmosphere%20and%20Volatile%20EvolutioN%20(MAVEN)%20(A)",
      "download": "https://raw.githubusercontent.com/nasa/NASA-3D-Resources/11ebb4ee043715aefbba6aeec8a61746fad67fa7/3D%20Models/Mars%20Atmosphere%20and%20Volatile%20EvolutioN%20(MAVEN)%20(A)/Mars%20Atmosphere%20and%20Volatile%20EvolutioN%20(MAVEN)%20(A).glb",
      "sourceSha256": "167484bdb26900ace3185389089f419a4cf9eb04e62f595049fdb4b0968283da",
      "credit": "NASA; source credits and model configuration retained in the linked source catalogue",
      "usage": "NASA media usage guidelines; no endorsement implied",
      "usageUrl": "https://www.nasa.gov/nasa-brand-center/images-and-media/"
    },
    "sha256": "03951753ddd6c78c35734c35e973c3aeceadcd781fc2311a4996a3ab0581781f",
    "bytes": 10897212
  },
  {
    "id": "odyssey",
    "label": "Mars Odyssey",
    "missionIds": [
      "odyssey"
    ],
    "noradIds": [],
    "spanM": 5.7,
    "sources": [
      "https://science.nasa.gov/mission/odyssey/"
    ],
    "kind": "official",
    "note": "NASA public visualization model, optimized for browser inspection. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_odyssey",
    "modelUrl": "/models/spacecraft/odyssey.glb",
    "metersPerUnit": 1,
    "boundsM": [
      3.9301,
      2.3298,
      5.7
    ],
    "parts": [
      "exterior_structure"
    ],
    "provenance": {
      "source": "https://github.com/nasa/NASA-3D-Resources/tree/11ebb4ee043715aefbba6aeec8a61746fad67fa7/3D%20Models/Mars%20Odyssey",
      "download": "https://raw.githubusercontent.com/nasa/NASA-3D-Resources/11ebb4ee043715aefbba6aeec8a61746fad67fa7/3D%20Models/Mars%20Odyssey/Mars%20Odyssey.glb",
      "sourceSha256": "ac0faa8dbfb54aabcbe3d06886c3d98dd29d120fd49b1c9fa6abbfbed22b049a",
      "credit": "NASA; source credits and model configuration retained in the linked source catalogue",
      "usage": "NASA media usage guidelines; no endorsement implied",
      "usageUrl": "https://www.nasa.gov/nasa-brand-center/images-and-media/"
    },
    "sha256": "3281a66bed9124cade8f105aa89a73a1f6dd056eaeb5e68dcf32fb12b692d55b",
    "bytes": 439712
  },
  {
    "id": "perseverance",
    "label": "Perseverance",
    "missionIds": [
      "perseverance"
    ],
    "noradIds": [],
    "spanM": 3,
    "sources": [
      "https://science.nasa.gov/mission/perseverance/"
    ],
    "kind": "official",
    "note": "NASA public visualization model, optimized for browser inspection. NASA rover reference shown in the inspection studio; the model does not imply an Earth orbit. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_perseverance",
    "modelUrl": "/models/spacecraft/perseverance.glb",
    "metersPerUnit": 1,
    "boundsM": [
      2.6104,
      1.7813,
      3
    ],
    "parts": [
      "rover_exterior",
      "mobility",
      "camera_assemblies"
    ],
    "provenance": {
      "source": "https://github.com/nasa/NASA-3D-Resources/tree/11ebb4ee043715aefbba6aeec8a61746fad67fa7/3D%20Models/Mars%202020%20Perseverance%20Rover",
      "download": "https://raw.githubusercontent.com/nasa/NASA-3D-Resources/11ebb4ee043715aefbba6aeec8a61746fad67fa7/3D%20Models/Mars%202020%20Perseverance%20Rover/Mars%202020%20Perseverance%20Rover.glb",
      "sourceSha256": "10db7c03a5e63a5a3b3e7baa6243aa4918ba045fa8ff0a731d0217491adc727f",
      "credit": "NASA; source credits and model configuration retained in the linked source catalogue",
      "usage": "NASA media usage guidelines; no endorsement implied",
      "usageUrl": "https://www.nasa.gov/nasa-brand-center/images-and-media/"
    },
    "sha256": "adaa89667e808458e3074d4d7fedf6c6760e5656a34b8d94baccff87c3932df1",
    "bytes": 2295800
  },
  {
    "id": "juno",
    "label": "Juno",
    "missionIds": [
      "juno"
    ],
    "noradIds": [],
    "spanM": 20,
    "sources": [
      "https://science.nasa.gov/mission/juno/"
    ],
    "kind": "official",
    "note": "NASA public visualization model, optimized for browser inspection. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_juno",
    "modelUrl": "/models/spacecraft/juno.glb",
    "metersPerUnit": 1,
    "boundsM": [
      19.0417,
      4.5919,
      20
    ],
    "parts": [
      "exterior_structure",
      "antenna_assemblies",
      "solar_arrays"
    ],
    "provenance": {
      "source": "https://github.com/nasa/NASA-3D-Resources/tree/11ebb4ee043715aefbba6aeec8a61746fad67fa7/3D%20Models/Juno%20(A)",
      "download": "https://raw.githubusercontent.com/nasa/NASA-3D-Resources/11ebb4ee043715aefbba6aeec8a61746fad67fa7/3D%20Models/Juno%20(A)/Juno%20(A).glb",
      "sourceSha256": "13f6bd48ff830a1890b21ef6e0182bb1043926feebb77af9733e7374b050367a",
      "credit": "NASA; source credits and model configuration retained in the linked source catalogue",
      "usage": "NASA media usage guidelines; no endorsement implied",
      "usageUrl": "https://www.nasa.gov/nasa-brand-center/images-and-media/"
    },
    "sha256": "33105cb5c5b7aa1ad69af90d135b839d58574fc41c0c6541fef6073ada9dd6e0",
    "bytes": 874244
  },
  {
    "id": "osiris",
    "label": "OSIRIS-REx / OSIRIS-APEX",
    "missionIds": [
      "osiris_apex"
    ],
    "noradIds": [],
    "spanM": 6.2,
    "sources": [
      "https://science.nasa.gov/mission/osiris/"
    ],
    "kind": "official",
    "note": "NASA public visualization model, optimized for browser inspection. NASA OSIRIS-REx source geometry used as an OSIRIS-APEX mission reference. Source includes the earlier sampling configuration. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_osiris",
    "modelUrl": "/models/spacecraft/osiris.glb",
    "metersPerUnit": 1,
    "boundsM": [
      2.4556,
      2.1486,
      6.2
    ],
    "parts": [
      "exterior_structure"
    ],
    "provenance": {
      "source": "https://github.com/nasa/NASA-3D-Resources/tree/11ebb4ee043715aefbba6aeec8a61746fad67fa7/3D%20Models/Origins%2C%20Spectral%20Interpretation%2C%20Resource%20Identification%2C%20and%20Security%20-%20Regolith%20Explorer%20(OSIRIS-REx)",
      "download": "https://raw.githubusercontent.com/nasa/NASA-3D-Resources/11ebb4ee043715aefbba6aeec8a61746fad67fa7/3D%20Models/Origins%2C%20Spectral%20Interpretation%2C%20Resource%20Identification%2C%20and%20Security%20-%20Regolith%20Explorer%20(OSIRIS-REx)/OSIRIS-REx.glb",
      "sourceSha256": "ef8e0429ee4dd8e918908923d5efdc6d3576b9216cc8e16533b50dd28c196bca",
      "credit": "NASA; source credits and model configuration retained in the linked source catalogue",
      "usage": "NASA media usage guidelines; no endorsement implied",
      "usageUrl": "https://www.nasa.gov/nasa-brand-center/images-and-media/"
    },
    "sha256": "30d4c1619062d1467f5ef2ccab1ed0ca957c44d467bf0d2bc17d7e8436313f47",
    "bytes": 1344420
  },
  {
    "id": "parker",
    "label": "Parker Solar Probe",
    "missionIds": [
      "parker_solar_probe"
    ],
    "noradIds": [],
    "spanM": 3,
    "sources": [
      "https://science.nasa.gov/mission/parker/"
    ],
    "kind": "official",
    "note": "NASA public visualization model, optimized for browser inspection. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_parker",
    "modelUrl": "/models/spacecraft/parker.glb",
    "metersPerUnit": 1,
    "boundsM": [
      2.6084,
      2.3883,
      3
    ],
    "parts": [
      "exterior_structure",
      "shielding",
      "antenna_assemblies",
      "solar_arrays"
    ],
    "provenance": {
      "source": "https://github.com/nasa/NASA-3D-Resources/tree/11ebb4ee043715aefbba6aeec8a61746fad67fa7/3D%20Models/Parker%20Solar%20Probe",
      "download": "https://raw.githubusercontent.com/nasa/NASA-3D-Resources/11ebb4ee043715aefbba6aeec8a61746fad67fa7/3D%20Models/Parker%20Solar%20Probe/Parker%20Solar%20Probe.glb",
      "sourceSha256": "4d26e84efd29a78c5d07e474f6272bb111668b58da5a7555e305a65c72ddb1c5",
      "credit": "NASA; source credits and model configuration retained in the linked source catalogue",
      "usage": "NASA media usage guidelines; no endorsement implied",
      "usageUrl": "https://www.nasa.gov/nasa-brand-center/images-and-media/"
    },
    "sha256": "87931a8bc449e1899ca08311c9ff6e8fd5db8887eead82f4c38ca549fd317523",
    "bytes": 412316
  },
  {
    "id": "soho",
    "label": "SOHO",
    "missionIds": [
      "soho"
    ],
    "noradIds": [
      "23726"
    ],
    "spanM": 9.5,
    "sources": [
      "https://science.nasa.gov/mission/soho/"
    ],
    "kind": "official",
    "note": "NASA public visualization model, optimized for browser inspection. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_soho",
    "modelUrl": "/models/spacecraft/soho.glb",
    "metersPerUnit": 1,
    "boundsM": [
      9.5,
      3.1678,
      3.808
    ],
    "parts": [
      "exterior_structure"
    ],
    "provenance": {
      "source": "https://github.com/nasa/NASA-3D-Resources/tree/11ebb4ee043715aefbba6aeec8a61746fad67fa7/3D%20Models/Solar%20and%20Heliospheric%20Observatory",
      "download": "https://raw.githubusercontent.com/nasa/NASA-3D-Resources/11ebb4ee043715aefbba6aeec8a61746fad67fa7/3D%20Models/Solar%20and%20Heliospheric%20Observatory/Solar%20and%20Heliospheric%20Observatory.glb",
      "sourceSha256": "fac23d6f1032bf08833b08d81a9c945f81e2883ca974f37ff7d99fb94a320d93",
      "credit": "NASA; source credits and model configuration retained in the linked source catalogue",
      "usage": "NASA media usage guidelines; no endorsement implied",
      "usageUrl": "https://www.nasa.gov/nasa-brand-center/images-and-media/"
    },
    "sha256": "b56817fb7f86d7c1aac3a8d7fb837d6861dfb0b53b275b11b6babb178365f058",
    "bytes": 147936
  },
  {
    "id": "stereo",
    "label": "STEREO",
    "missionIds": [
      "stereo_a"
    ],
    "noradIds": [
      "29510"
    ],
    "spanM": 6.4,
    "sources": [
      "https://science.nasa.gov/mission/stereo/"
    ],
    "kind": "official",
    "note": "NASA public visualization model, optimized for browser inspection. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_stereo",
    "modelUrl": "/models/spacecraft/stereo.glb",
    "metersPerUnit": 1,
    "boundsM": [
      6.4,
      4.9396,
      4.9585
    ],
    "parts": [
      "exterior_structure"
    ],
    "provenance": {
      "source": "https://github.com/nasa/NASA-3D-Resources/tree/11ebb4ee043715aefbba6aeec8a61746fad67fa7/3D%20Models/Solar%20TErrestrial%20RElations%20Observatory%20(STEREO)",
      "download": "https://raw.githubusercontent.com/nasa/NASA-3D-Resources/11ebb4ee043715aefbba6aeec8a61746fad67fa7/3D%20Models/Solar%20TErrestrial%20RElations%20Observatory%20(STEREO)/Solar%20TErrestrial%20RElations%20Observatory%20(STEREO).glb",
      "sourceSha256": "0215f18b40bebb3652398b60e51cb5d8c6a4100a33a6a31768b9087d6239d9bf",
      "credit": "NASA; source credits and model configuration retained in the linked source catalogue",
      "usage": "NASA media usage guidelines; no endorsement implied",
      "usageUrl": "https://www.nasa.gov/nasa-brand-center/images-and-media/"
    },
    "sha256": "7baca747d5bd66cefed7174cbe7645af1f6419da20282b2d8492fafce7c0901f",
    "bytes": 377700
  },
  {
    "id": "voyager",
    "label": "Voyager",
    "missionIds": [
      "voyager1",
      "voyager2"
    ],
    "noradIds": [],
    "spanM": 13,
    "sources": [
      "https://science.nasa.gov/mission/voyager/"
    ],
    "kind": "official",
    "note": "NASA public visualization model, optimized for browser inspection. Shared NASA Voyager reference geometry; no current boom attitude or flight-unit configuration is inferred. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_voyager",
    "modelUrl": "/models/spacecraft/voyager.glb",
    "metersPerUnit": 1,
    "boundsM": [
      5.96,
      8.4857,
      13
    ],
    "parts": [
      "exterior_structure"
    ],
    "provenance": {
      "source": "https://github.com/nasa/NASA-3D-Resources/tree/11ebb4ee043715aefbba6aeec8a61746fad67fa7/3D%20Models/Voyager%20Probe%20(B)",
      "download": "https://raw.githubusercontent.com/nasa/NASA-3D-Resources/11ebb4ee043715aefbba6aeec8a61746fad67fa7/3D%20Models/Voyager%20Probe%20(B)/Voyager%20Probe%20(B).glb",
      "sourceSha256": "bd86ded828dd3f459293aee4ffc3cd0998d8db67439317c8299650a1174c3289",
      "credit": "NASA; source credits and model configuration retained in the linked source catalogue",
      "usage": "NASA media usage guidelines; no endorsement implied",
      "usageUrl": "https://www.nasa.gov/nasa-brand-center/images-and-media/"
    },
    "sha256": "a30cfa7d6bf5ee4506bf6c738889c2074fb99daea8dc1580e290f53ce8b16cb4",
    "bytes": 327972
  },
  {
    "id": "mir",
    "label": "Mir (historical)",
    "missionIds": [],
    "noradIds": [],
    "spanM": 30,
    "sources": [
      "https://science.nasa.gov/mission/mir/"
    ],
    "kind": "official",
    "note": "NASA public visualization model, optimized for browser inspection. Historical NASA reference, never substituted for ISS or Tiangong. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_mir",
    "modelUrl": "/models/spacecraft/mir.glb",
    "metersPerUnit": 1,
    "boundsM": [
      18.449,
      30,
      24.8196
    ],
    "parts": [
      "exterior_structure"
    ],
    "provenance": {
      "source": "https://github.com/nasa/NASA-3D-Resources/tree/11ebb4ee043715aefbba6aeec8a61746fad67fa7/3D%20Models/Mir",
      "download": "https://raw.githubusercontent.com/nasa/NASA-3D-Resources/11ebb4ee043715aefbba6aeec8a61746fad67fa7/3D%20Models/Mir/Mir.glb",
      "sourceSha256": "afd22638606c5545f6f730f4c663640912b17cedd1f677ca4e8cf01b6d4819e4",
      "credit": "NASA; source credits and model configuration retained in the linked source catalogue",
      "usage": "NASA media usage guidelines; no endorsement implied",
      "usageUrl": "https://www.nasa.gov/nasa-brand-center/images-and-media/"
    },
    "sha256": "c5e4600910fb67bfee1203fe18b5982812d16dafb09c7abd37e7e5e7db9eac42",
    "bytes": 30852
  },
  {
    "id": "skylab",
    "label": "Skylab (historical)",
    "missionIds": [],
    "noradIds": [],
    "spanM": 25,
    "sources": [
      "https://science.nasa.gov/mission/skylab/"
    ],
    "kind": "official",
    "note": "NASA public visualization model, optimized for browser inspection. Historical NASA reference, never substituted for an active station. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_skylab",
    "modelUrl": "/models/spacecraft/skylab.glb",
    "metersPerUnit": 1,
    "boundsM": [
      25,
      7.6028,
      19.264
    ],
    "parts": [
      "exterior_structure"
    ],
    "provenance": {
      "source": "https://github.com/nasa/NASA-3D-Resources/tree/11ebb4ee043715aefbba6aeec8a61746fad67fa7/3D%20Models/Skylab",
      "download": "https://raw.githubusercontent.com/nasa/NASA-3D-Resources/11ebb4ee043715aefbba6aeec8a61746fad67fa7/3D%20Models/Skylab/Skylab.glb",
      "sourceSha256": "6246d3ba63a5950688020609a123c67816b15df1b8b155b43bd8e6a9da8f5b44",
      "credit": "NASA; source credits and model configuration retained in the linked source catalogue",
      "usage": "NASA media usage guidelines; no endorsement implied",
      "usageUrl": "https://www.nasa.gov/nasa-brand-center/images-and-media/"
    },
    "sha256": "18229e38547fb137f1b604ee18df7723706022f31b41d6048e077a8438b22ba9",
    "bytes": 146824
  },
  {
    "id": "europa",
    "label": "Europa Clipper",
    "missionIds": [
      "europa_clipper"
    ],
    "noradIds": [],
    "spanM": 30.5,
    "sources": [
      "https://science.nasa.gov/resource/europa-clipper-3d-model/"
    ],
    "kind": "official",
    "note": "NASA public visualization model, optimized for browser inspection. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_europa",
    "modelUrl": "/models/spacecraft/europa.glb",
    "metersPerUnit": 1,
    "boundsM": [
      30.5,
      11.2527,
      18.0027
    ],
    "parts": [
      "exterior_structure"
    ],
    "provenance": {
      "source": "https://science.nasa.gov/resource/europa-clipper-3d-model/",
      "download": "https://assets.science.nasa.gov/content/dam/science/psd/solar/2023/09/c/clipper_spacecraft.glb",
      "sourceSha256": "a3f5e4533b31bf4bb25f4332f6879055dfd744f3ff9add23bfa9bdfbefd4f7fe",
      "credit": "NASA; source credits and model configuration retained in the linked source catalogue",
      "usage": "NASA media usage guidelines; no endorsement implied",
      "usageUrl": "https://www.nasa.gov/nasa-brand-center/images-and-media/"
    },
    "sha256": "ffa6997726fbfcbd5f5bdba5675d715509cd7204bea27982bfb3bc6ea81749b2",
    "bytes": 4356700
  },
  {
    "id": "orion",
    "label": "Orion with European Service Module",
    "missionIds": [
      "orion_artemis",
      "artemis2_orion"
    ],
    "noradIds": [],
    "spanM": 19,
    "sources": [
      "https://www.esa.int/Science_Exploration/Human_and_Robotic_Exploration/Orion"
    ],
    "pattern": "^ORION\\b",
    "kind": "reconstruction",
    "note": "Source-informed exterior reconstruction. Crew module, service module and four solar wings reconstructed from public ESA/NASA illustrations. Approximate exterior, not mission-specific CAD. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_orion",
    "modelUrl": "/models/spacecraft/orion.glb",
    "metersPerUnit": 1,
    "boundsM": [
      19,
      13.2926,
      19
    ],
    "parts": [
      "service_module",
      "crew_or_cargo_module",
      "solar_arrays",
      "docking_interface"
    ],
    "provenance": {
      "source": "https://www.esa.int/Science_Exploration/Human_and_Robotic_Exploration/Orion",
      "credit": "Original Entarian exterior reconstruction from public mission references",
      "usage": "Original geometry; linked photographs are references and are not redistributed in the model"
    },
    "sha256": "6d946eb04f12bdb1240b336104a8d64d7ebe9d22ed50c4ef4218729d7bf70c8d",
    "bytes": 26640
  },
  {
    "id": "tiangong",
    "label": "Tiangong space station",
    "missionIds": [],
    "noradIds": [
      "48274"
    ],
    "spanM": 55,
    "sources": [
      "https://en.cmse.gov.cn/missions/space_station/"
    ],
    "pattern": "^(CSS|TIANGONG|TIANHE|WENTIAN|MENGTIAN)\\b",
    "kind": "reconstruction",
    "note": "Source-informed exterior reconstruction. Three-module station exterior reconstruction. Source configuration is illustrative; docked visiting vehicles and current appendage attitude are not tracked. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_tiangong",
    "modelUrl": "/models/spacecraft/tiangong.glb",
    "metersPerUnit": 1,
    "boundsM": [
      55,
      6.5208,
      51.8006
    ],
    "parts": [
      "tianhe_core",
      "wentian_lab",
      "mengtian_lab",
      "tianhe_solar_arrays",
      "docking_hub"
    ],
    "provenance": {
      "source": "https://en.cmse.gov.cn/missions/space_station/",
      "credit": "Original Entarian exterior reconstruction from public mission references",
      "usage": "Original geometry; linked photographs are references and are not redistributed in the model"
    },
    "sha256": "92fd54b6b175dc9c169db4a3aab6ed0c358486c771339fa38994d26d376e1631",
    "bytes": 70044
  },
  {
    "id": "soyuz",
    "label": "Soyuz spacecraft",
    "missionIds": [],
    "noradIds": [],
    "spanM": 10.6,
    "sources": [
      "https://www.esa.int/Science_Exploration/Human_and_Robotic_Exploration/International_Space_Station/Soyuz"
    ],
    "pattern": "^SOYUZ",
    "kind": "reconstruction",
    "note": "Source-informed exterior reconstruction. Shared three-module Soyuz reference; flight-specific changes and docking state are not represented. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_soyuz",
    "modelUrl": "/models/spacecraft/soyuz.glb",
    "metersPerUnit": 1,
    "boundsM": [
      10.6,
      7.9199,
      2.7705
    ],
    "parts": [
      "service_module",
      "crew_or_cargo_module",
      "solar_arrays",
      "docking_interface",
      "orbital_module"
    ],
    "provenance": {
      "source": "https://www.esa.int/Science_Exploration/Human_and_Robotic_Exploration/International_Space_Station/Soyuz",
      "credit": "Original Entarian exterior reconstruction from public mission references",
      "usage": "Original geometry; linked photographs are references and are not redistributed in the model"
    },
    "sha256": "1c72b44e833cef001e29ee2995738398cde2e42ca71d6034a3aeebd71e27875e",
    "bytes": 32432
  },
  {
    "id": "progress",
    "label": "Progress cargo spacecraft",
    "missionIds": [],
    "noradIds": [],
    "spanM": 10.6,
    "sources": [
      "https://www.nasa.gov/international-space-station/space-station-visiting-vehicles/"
    ],
    "pattern": "^PROGRESS",
    "kind": "reconstruction",
    "note": "Source-informed exterior reconstruction. Cargo vehicle family exterior reconstruction; no flight-specific configuration. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_progress",
    "modelUrl": "/models/spacecraft/progress.glb",
    "metersPerUnit": 1,
    "boundsM": [
      10.6,
      7.9199,
      2.7705
    ],
    "parts": [
      "service_module",
      "crew_or_cargo_module",
      "solar_arrays",
      "docking_interface",
      "orbital_module"
    ],
    "provenance": {
      "source": "https://www.nasa.gov/international-space-station/space-station-visiting-vehicles/",
      "credit": "Original Entarian exterior reconstruction from public mission references",
      "usage": "Original geometry; linked photographs are references and are not redistributed in the model"
    },
    "sha256": "1c72b44e833cef001e29ee2995738398cde2e42ca71d6034a3aeebd71e27875e",
    "bytes": 32432
  },
  {
    "id": "dragon",
    "label": "Dragon spacecraft",
    "missionIds": [
      "commercial_crew"
    ],
    "noradIds": [],
    "spanM": 8.1,
    "sources": [
      "https://www.spacex.com/vehicles/dragon/"
    ],
    "pattern": "^(CREW DRAGON|DRAGON|CREW-)",
    "kind": "reconstruction",
    "note": "Source-informed exterior reconstruction. Dragon family exterior reconstruction. The Commercial Crew programme row is shown using Dragon as a representative vehicle; it also includes Starliner. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_dragon",
    "modelUrl": "/models/spacecraft/dragon.glb",
    "metersPerUnit": 1,
    "boundsM": [
      4.7271,
      8.1,
      4.7426
    ],
    "parts": [
      "service_module",
      "crew_or_cargo_module",
      "solar_arrays",
      "docking_interface"
    ],
    "provenance": {
      "source": "https://www.spacex.com/vehicles/dragon/",
      "credit": "Original Entarian exterior reconstruction from public mission references",
      "usage": "Original geometry; linked photographs are references and are not redistributed in the model"
    },
    "sha256": "c4a7f6b754377af177bc91112ccd4706891d2a370503066781dd99911e684fc7",
    "bytes": 11296
  },
  {
    "id": "tianzhou",
    "label": "Tianzhou cargo spacecraft",
    "missionIds": [],
    "noradIds": [],
    "spanM": 14.9,
    "sources": [
      "https://en.cmse.gov.cn/missions/tianzhou/"
    ],
    "pattern": "^TIANZHOU",
    "kind": "reconstruction",
    "note": "Source-informed exterior reconstruction. Public exterior family reconstruction, approximate proportions; docking state is not tracked. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_tianzhou",
    "modelUrl": "/models/spacecraft/tianzhou.glb",
    "metersPerUnit": 1,
    "boundsM": [
      14.9,
      9.9474,
      5.5875
    ],
    "parts": [
      "service_module",
      "crew_or_cargo_module",
      "solar_arrays",
      "docking_interface"
    ],
    "provenance": {
      "source": "https://en.cmse.gov.cn/missions/tianzhou/",
      "credit": "Original Entarian exterior reconstruction from public mission references",
      "usage": "Original geometry; linked photographs are references and are not redistributed in the model"
    },
    "sha256": "6d244b693911f3154a31c1f9c7c53c21dac0f0502a0e393e22ea279151d74579",
    "bytes": 21996
  },
  {
    "id": "shenzhou",
    "label": "Shenzhou spacecraft",
    "missionIds": [],
    "noradIds": [],
    "spanM": 17,
    "sources": [
      "https://en.cmse.gov.cn/missions/shenzhou/"
    ],
    "pattern": "^SHENZHOU",
    "kind": "reconstruction",
    "note": "Source-informed exterior reconstruction. Public three-module family reconstruction with separate orbital and service-module solar arrays. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_shenzhou",
    "modelUrl": "/models/spacecraft/shenzhou.glb",
    "metersPerUnit": 1,
    "boundsM": [
      17,
      12.7017,
      4.4432
    ],
    "parts": [
      "service_module",
      "crew_or_cargo_module",
      "solar_arrays",
      "docking_interface",
      "orbital_module"
    ],
    "provenance": {
      "source": "https://en.cmse.gov.cn/missions/shenzhou/",
      "credit": "Original Entarian exterior reconstruction from public mission references",
      "usage": "Original geometry; linked photographs are references and are not redistributed in the model"
    },
    "sha256": "5142e093bc51374b85ae4c700c1834f81142f8aed3b357a38ebe37f2d91d42bc",
    "bytes": 40112
  },
  {
    "id": "cygnus",
    "label": "Cygnus cargo spacecraft",
    "missionIds": [],
    "noradIds": [],
    "spanM": 10,
    "sources": [
      "https://www.nasa.gov/international-space-station/space-station-visiting-vehicles/"
    ],
    "pattern": "^CYGNUS|^NG-[0-9]",
    "kind": "reconstruction",
    "note": "Source-informed exterior reconstruction. Enhanced Cygnus exterior reconstruction with circular solar arrays; approximate presentation scale. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_cygnus",
    "modelUrl": "/models/spacecraft/cygnus.glb",
    "metersPerUnit": 1,
    "boundsM": [
      10,
      5.25,
      3.3333
    ],
    "parts": [
      "service_module",
      "crew_or_cargo_module",
      "solar_arrays",
      "docking_interface"
    ],
    "provenance": {
      "source": "https://www.nasa.gov/international-space-station/space-station-visiting-vehicles/",
      "credit": "Original Entarian exterior reconstruction from public mission references",
      "usage": "Original geometry; linked photographs are references and are not redistributed in the model"
    },
    "sha256": "a4f75218763bd6784e6689829583e5114e6f5dcc2f4813a46f75f00c21d53aba",
    "bytes": 42224
  },
  {
    "id": "gps3",
    "label": "GPS III",
    "missionIds": [
      "gps3_sv01",
      "gps3_sv02",
      "gps3_sv03",
      "gps3_sv04",
      "gps3_sv05",
      "gps3_sv06"
    ],
    "noradIds": [],
    "spanM": 17,
    "sources": [
      "https://www.lockheedmartin.com/en-us/products/gps.html"
    ],
    "pattern": "^GPS.*(III|BIII)",
    "kind": "reconstruction",
    "note": "Source-informed exterior reconstruction. Public GPS III family reconstruction. Individual vehicle hardware and antenna geometry are simplified. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_gps3",
    "modelUrl": "/models/spacecraft/gps3.glb",
    "metersPerUnit": 1,
    "boundsM": [
      17,
      3.3277,
      2.4083
    ],
    "parts": [
      "spacecraft_bus",
      "solar_arrays",
      "payload_exterior"
    ],
    "provenance": {
      "source": "https://www.lockheedmartin.com/en-us/products/gps.html",
      "credit": "Original Entarian exterior reconstruction from public mission references",
      "usage": "Original geometry; linked photographs are references and are not redistributed in the model"
    },
    "sha256": "c5b892592461ae819b55ad6ffd185db6fc521a56fd321a16492c5e9bfa08b6af",
    "bytes": 46880
  },
  {
    "id": "gps2",
    "label": "GPS Block II family",
    "missionIds": [],
    "noradIds": [],
    "spanM": 11,
    "sources": [
      "https://www.gps.gov/systems/gps/space/"
    ],
    "pattern": "^GPS",
    "kind": "reconstruction",
    "note": "Source-informed exterior reconstruction. Representative Block II exterior. IIA/IIR/IIF variants differ; this family reference is not an exact block replica. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_gps2",
    "modelUrl": "/models/spacecraft/gps2.glb",
    "metersPerUnit": 1,
    "boundsM": [
      11,
      2.1532,
      1.5583
    ],
    "parts": [
      "spacecraft_bus",
      "solar_arrays",
      "payload_exterior"
    ],
    "provenance": {
      "source": "https://www.gps.gov/systems/gps/space/",
      "credit": "Original Entarian exterior reconstruction from public mission references",
      "usage": "Original geometry; linked photographs are references and are not redistributed in the model"
    },
    "sha256": "ab2f0bd1b50882cfe41a64cda37e070bb73660fa87b2ec5f49c2d66aa2e490b8",
    "bytes": 46888
  },
  {
    "id": "galileo",
    "label": "Galileo FOC",
    "missionIds": [],
    "noradIds": [],
    "spanM": 14.7,
    "sources": [
      "https://www.esa.int/Applications/Satellite_navigation/Galileo/What_is_Galileo"
    ],
    "pattern": "^GALILEO",
    "kind": "reconstruction",
    "note": "Source-informed exterior reconstruction. Galileo FOC exterior reconstruction; IOV and second-generation vehicles differ. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_galileo",
    "modelUrl": "/models/spacecraft/galileo.glb",
    "metersPerUnit": 1,
    "boundsM": [
      14.7,
      2.8775,
      2.0825
    ],
    "parts": [
      "spacecraft_bus",
      "solar_arrays",
      "payload_exterior"
    ],
    "provenance": {
      "source": "https://www.esa.int/Applications/Satellite_navigation/Galileo/What_is_Galileo",
      "credit": "Original Entarian exterior reconstruction from public mission references",
      "usage": "Original geometry; linked photographs are references and are not redistributed in the model"
    },
    "sha256": "ef48644a40f9b2a382200b5300490a66f2224a82eddedb4e437d22996f28b738",
    "bytes": 46888
  },
  {
    "id": "glonass",
    "label": "GLONASS-M",
    "missionIds": [],
    "noradIds": [],
    "spanM": 7.2,
    "sources": [
      "https://www.glonass-iac.ru/en/GLONASS/"
    ],
    "pattern": "^COSMOS.*GLONASS|^GLONASS",
    "kind": "reconstruction",
    "note": "Source-informed exterior reconstruction. GLONASS-M cylindrical-bus family reference. K/K2 variants are not the same spacecraft and remain approximate here. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_glonass",
    "modelUrl": "/models/spacecraft/glonass.glb",
    "metersPerUnit": 1,
    "boundsM": [
      7.2,
      1.404,
      1.02
    ],
    "parts": [
      "spacecraft_bus",
      "solar_arrays",
      "payload_exterior"
    ],
    "provenance": {
      "source": "https://www.glonass-iac.ru/en/GLONASS/",
      "credit": "Original Entarian exterior reconstruction from public mission references",
      "usage": "Original geometry; linked photographs are references and are not redistributed in the model"
    },
    "sha256": "aaf36378ce8726f915ba680f7448759e198a3c2948906f33252aca1a22869638",
    "bytes": 29880
  },
  {
    "id": "beidou",
    "label": "BeiDou navigation family",
    "missionIds": [],
    "noradIds": [],
    "spanM": 12,
    "sources": [
      "https://en.beidou.gov.cn/SYSTEMS/System/"
    ],
    "pattern": "^BEIDOU",
    "kind": "reconstruction",
    "note": "Source-informed exterior reconstruction. Representative BeiDou MEO external layout; GEO and IGSO variants differ and are not exact replicas. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_beidou",
    "modelUrl": "/models/spacecraft/beidou.glb",
    "metersPerUnit": 1,
    "boundsM": [
      12,
      2.349,
      1.7
    ],
    "parts": [
      "spacecraft_bus",
      "solar_arrays",
      "payload_exterior"
    ],
    "provenance": {
      "source": "https://en.beidou.gov.cn/SYSTEMS/System/",
      "credit": "Original Entarian exterior reconstruction from public mission references",
      "usage": "Original geometry; linked photographs are references and are not redistributed in the model"
    },
    "sha256": "7e2414d587f7dd49e20c14d6a78ebb557b84db3b645d420662090a72340f020e",
    "bytes": 46820
  },
  {
    "id": "sentinel1",
    "label": "Sentinel-1",
    "missionIds": [],
    "noradIds": [],
    "spanM": 12,
    "sources": [
      "https://www.esa.int/Applications/Observing_the_Earth/Copernicus/Sentinel-1"
    ],
    "pattern": "^SENTINEL-1",
    "kind": "reconstruction",
    "note": "Source-informed exterior reconstruction. Sentinel-1 family reconstruction including the long C-band SAR antenna. Instrument housings and scale approximate. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_sentinel1",
    "modelUrl": "/models/spacecraft/sentinel1.glb",
    "metersPerUnit": 1,
    "boundsM": [
      12,
      2.71,
      1.7
    ],
    "parts": [
      "spacecraft_bus",
      "solar_arrays",
      "payload_exterior"
    ],
    "provenance": {
      "source": "https://www.esa.int/Applications/Observing_the_Earth/Copernicus/Sentinel-1",
      "credit": "Original Entarian exterior reconstruction from public mission references",
      "usage": "Original geometry; linked photographs are references and are not redistributed in the model"
    },
    "sha256": "88c5bbea9162459fe1eca5a03869ce1ff0d9887b40f5b8e1092a0be72d4d9ac4",
    "bytes": 40096
  },
  {
    "id": "sentinel2",
    "label": "Sentinel-2",
    "missionIds": [],
    "noradIds": [],
    "spanM": 7.5,
    "sources": [
      "https://www.esa.int/Applications/Observing_the_Earth/Copernicus/Sentinel-2"
    ],
    "pattern": "^SENTINEL-2",
    "kind": "reconstruction",
    "note": "Source-informed exterior reconstruction. Sentinel-2 family exterior reconstruction with a single solar wing and optical payload aperture. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_sentinel2",
    "modelUrl": "/models/spacecraft/sentinel2.glb",
    "metersPerUnit": 1,
    "boundsM": [
      7.5,
      3.3824,
      1.8519
    ],
    "parts": [
      "spacecraft_bus",
      "solar_arrays",
      "payload_exterior"
    ],
    "provenance": {
      "source": "https://www.esa.int/Applications/Observing_the_Earth/Copernicus/Sentinel-2",
      "credit": "Original Entarian exterior reconstruction from public mission references",
      "usage": "Original geometry; linked photographs are references and are not redistributed in the model"
    },
    "sha256": "83059aa0a1bb1b3aacc29b02853c88eb5b1eab7996e17f406d7dea241b896cac",
    "bytes": 37520
  },
  {
    "id": "sentinel3",
    "label": "Sentinel-3",
    "missionIds": [],
    "noradIds": [],
    "spanM": 11,
    "sources": [
      "https://www.esa.int/Applications/Observing_the_Earth/Copernicus/Sentinel-3"
    ],
    "pattern": "^SENTINEL-3",
    "kind": "reconstruction",
    "note": "Source-informed exterior reconstruction. Sentinel-3 family exterior reconstruction; simplified sensor deck and single solar wing. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_sentinel3",
    "modelUrl": "/models/spacecraft/sentinel3.glb",
    "metersPerUnit": 1,
    "boundsM": [
      11,
      4.9608,
      4.0261
    ],
    "parts": [
      "spacecraft_bus",
      "solar_arrays",
      "payload_exterior"
    ],
    "provenance": {
      "source": "https://www.esa.int/Applications/Observing_the_Earth/Copernicus/Sentinel-3",
      "credit": "Original Entarian exterior reconstruction from public mission references",
      "usage": "Original geometry; linked photographs are references and are not redistributed in the model"
    },
    "sha256": "36ad9713ea3979cca33b8b2d479941e9de2c2cf13ce763601e98e562f36995ad",
    "bytes": 56176
  },
  {
    "id": "sentinel5p",
    "label": "Sentinel-5P",
    "missionIds": [],
    "noradIds": [],
    "spanM": 6,
    "sources": [
      "https://www.esa.int/Applications/Observing_the_Earth/Copernicus/Sentinel-5P"
    ],
    "pattern": "^SENTINEL-5",
    "kind": "reconstruction",
    "note": "Source-informed exterior reconstruction. Sentinel-5P exterior reconstruction with three radial solar panels and TROPOMI housing. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_sentinel5p",
    "modelUrl": "/models/spacecraft/sentinel5p.glb",
    "metersPerUnit": 1,
    "boundsM": [
      5.2258,
      3.6818,
      6
    ],
    "parts": [
      "spacecraft_bus",
      "solar_arrays",
      "payload_exterior"
    ],
    "provenance": {
      "source": "https://www.esa.int/Applications/Observing_the_Earth/Copernicus/Sentinel-5P",
      "credit": "Original Entarian exterior reconstruction from public mission references",
      "usage": "Original geometry; linked photographs are references and are not redistributed in the model"
    },
    "sha256": "cbc1954f415ccc21d31003aa3d99dfd226f2da015ee450a86b4e46373b035a85",
    "bytes": 38004
  },
  {
    "id": "oneweb",
    "label": "OneWeb first-generation spacecraft",
    "missionIds": [],
    "noradIds": [],
    "spanM": 5,
    "sources": [
      "https://www.eutelsat.com/en/satellites/leo-constellation.html"
    ],
    "pattern": "^ONEWEB",
    "kind": "reconstruction",
    "note": "Source-informed exterior reconstruction. OneWeb family exterior reconstruction. Large constellation maps retain lightweight dots; this model loads only for inspection. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_oneweb",
    "modelUrl": "/models/spacecraft/oneweb.glb",
    "metersPerUnit": 1,
    "boundsM": [
      5,
      1.5076,
      1.4655
    ],
    "parts": [
      "spacecraft_bus",
      "solar_arrays",
      "payload_exterior"
    ],
    "provenance": {
      "source": "https://www.eutelsat.com/en/satellites/leo-constellation.html",
      "credit": "Original Entarian exterior reconstruction from public mission references",
      "usage": "Original geometry; linked photographs are references and are not redistributed in the model"
    },
    "sha256": "dcaec62a241eb2999ca97f8318d8df887a1b5e51f5ef260dea188902060d7085",
    "bytes": 46868
  },
  {
    "id": "starlink",
    "label": "Starlink flat-panel spacecraft",
    "missionIds": [],
    "noradIds": [],
    "spanM": 12,
    "sources": [
      "https://www.starlink.com/technology"
    ],
    "pattern": "^STARLINK",
    "kind": "reconstruction",
    "note": "Source-informed exterior reconstruction. Representative first-generation flat-panel layout. V2 Mini and later generations differ; no generation is inferred from a satellite number. Large constellations retain dots. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_starlink",
    "modelUrl": "/models/spacecraft/starlink.glb",
    "metersPerUnit": 1,
    "boundsM": [
      12,
      0.4591,
      3.1674
    ],
    "parts": [
      "spacecraft_bus",
      "solar_arrays",
      "payload_exterior"
    ],
    "provenance": {
      "source": "https://www.starlink.com/technology",
      "credit": "Original Entarian exterior reconstruction from public mission references",
      "usage": "Original geometry; linked photographs are references and are not redistributed in the model"
    },
    "sha256": "d8c48f18853eeab6b6122df1b5091e58e2bfc58200170dd698c7b3848cb56498",
    "bytes": 37732
  },
  {
    "id": "aehf",
    "label": "AEHF",
    "missionIds": [
      "aehf_4",
      "aehf_5",
      "aehf_6"
    ],
    "noradIds": [],
    "spanM": 28,
    "sources": [
      "https://www.spaceforce.mil/About-Us/Fact-Sheets/Article/2197713/advanced-extremely-high-frequency-system/"
    ],
    "pattern": "^AEHF",
    "kind": "reconstruction",
    "note": "Source-informed exterior reconstruction. Public exterior reconstruction only; classified payload detail, exact reflector profiles and flight configuration are not represented. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_aehf",
    "modelUrl": "/models/spacecraft/aehf.glb",
    "metersPerUnit": 1,
    "boundsM": [
      28,
      5.6729,
      3.5538
    ],
    "parts": [
      "spacecraft_bus",
      "solar_arrays",
      "communications_payload"
    ],
    "provenance": {
      "source": "https://www.spaceforce.mil/About-Us/Fact-Sheets/Article/2197713/advanced-extremely-high-frequency-system/",
      "credit": "Original Entarian exterior reconstruction from public mission references",
      "usage": "Original geometry; linked photographs are references and are not redistributed in the model"
    },
    "sha256": "b6711da73bf3b9f950c058171b793910394500448c051e7acd7fffc4320c8989",
    "bytes": 58476
  },
  {
    "id": "wgs",
    "label": "Wideband Global SATCOM",
    "missionIds": [
      "wgs_7",
      "wgs_8",
      "wgs_9",
      "wgs_10",
      "wgs_11"
    ],
    "noradIds": [],
    "spanM": 41,
    "sources": [
      "https://www.boeing.com/space/wideband-global-satcom-satellite"
    ],
    "pattern": "^WGS",
    "kind": "reconstruction",
    "note": "Source-informed exterior reconstruction. Boeing WGS family public exterior reconstruction; approximate structure and reflectors. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_wgs",
    "modelUrl": "/models/spacecraft/wgs.glb",
    "metersPerUnit": 1,
    "boundsM": [
      41,
      6.6724,
      10.3288
    ],
    "parts": [
      "spacecraft_bus",
      "solar_arrays",
      "communications_payload"
    ],
    "provenance": {
      "source": "https://www.boeing.com/space/wideband-global-satcom-satellite",
      "credit": "Original Entarian exterior reconstruction from public mission references",
      "usage": "Original geometry; linked photographs are references and are not redistributed in the model"
    },
    "sha256": "d114dd26de9dcc76004b7788875bec6f7009d9823aac1dccb0bebeb2bf0557fd",
    "bytes": 59736
  },
  {
    "id": "muos",
    "label": "MUOS",
    "missionIds": [
      "muos_3",
      "muos_4",
      "muos_5"
    ],
    "noradIds": [],
    "spanM": 28,
    "sources": [
      "https://www.lockheedmartin.com/en-us/products/mobile-user-objective-system-muos.html"
    ],
    "pattern": "^MUOS",
    "kind": "reconstruction",
    "note": "Source-informed exterior reconstruction. Public MUOS exterior reconstruction featuring the large mesh reflector and solar wings. Mesh geometry and scale approximate. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_muos",
    "modelUrl": "/models/spacecraft/muos.glb",
    "metersPerUnit": 1,
    "boundsM": [
      28,
      9.0394,
      9.4769
    ],
    "parts": [
      "spacecraft_bus",
      "solar_arrays",
      "communications_payload"
    ],
    "provenance": {
      "source": "https://www.lockheedmartin.com/en-us/products/mobile-user-objective-system-muos.html",
      "credit": "Original Entarian exterior reconstruction from public mission references",
      "usage": "Original geometry; linked photographs are references and are not redistributed in the model"
    },
    "sha256": "13d6cc0eecff7d09ff40c76358dd83c909f520e832f14d722ad96fbb6cdfc04b",
    "bytes": 105132
  },
  {
    "id": "sbirs",
    "label": "SBIRS GEO",
    "missionIds": [
      "sbirs_geo1",
      "sbirs_geo2",
      "sbirs_geo3"
    ],
    "noradIds": [],
    "spanM": 15,
    "sources": [
      "https://www.lockheedmartin.com/en-us/products/sbirs.html"
    ],
    "pattern": "^SBIRS.*GEO",
    "kind": "reconstruction",
    "note": "Source-informed exterior reconstruction. Public SBIRS GEO exterior reference, not the classified hosted HEO payload. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_sbirs",
    "modelUrl": "/models/spacecraft/sbirs.glb",
    "metersPerUnit": 1,
    "boundsM": [
      15,
      3.1046,
      1.875
    ],
    "parts": [
      "spacecraft_bus",
      "solar_arrays",
      "communications_payload"
    ],
    "provenance": {
      "source": "https://www.lockheedmartin.com/en-us/products/sbirs.html",
      "credit": "Original Entarian exterior reconstruction from public mission references",
      "usage": "Original geometry; linked photographs are references and are not redistributed in the model"
    },
    "sha256": "001f0d6f73f0afe152b08b5b2b79865ba2c96f8de0c462de21c4b0000d383aee",
    "bytes": 44560
  },
  {
    "id": "landsat9",
    "label": "Landsat 9",
    "missionIds": [
      "landsat9"
    ],
    "noradIds": [
      "49260"
    ],
    "spanM": 10,
    "sources": [
      "https://landsat.gsfc.nasa.gov/satellites/landsat-9/"
    ],
    "pattern": "^LANDSAT 9",
    "kind": "reconstruction",
    "note": "Source-informed exterior reconstruction. Exterior reconstruction with OLI-2/TIRS-2 housings and a single solar wing; approximate dimensions. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_landsat9",
    "modelUrl": "/models/spacecraft/landsat9.glb",
    "metersPerUnit": 1,
    "boundsM": [
      10,
      4.718,
      2.4917
    ],
    "parts": [
      "spacecraft_bus",
      "solar_arrays",
      "payload_exterior"
    ],
    "provenance": {
      "source": "https://landsat.gsfc.nasa.gov/satellites/landsat-9/",
      "credit": "Original Entarian exterior reconstruction from public mission references",
      "usage": "Original geometry; linked photographs are references and are not redistributed in the model"
    },
    "sha256": "8bbc3d9af9d79f507e171d504e4fc5f17ce13d88478b2021a14b6091d86536b2",
    "bytes": 40476
  },
  {
    "id": "pace",
    "label": "PACE",
    "missionIds": [
      "pace"
    ],
    "noradIds": [
      "58945"
    ],
    "spanM": 5,
    "sources": [
      "https://science.nasa.gov/blogs/pace/2024/02/08/meet-nasas-pace-spacecraft-science-instruments/"
    ],
    "pattern": "^PACE",
    "kind": "reconstruction",
    "note": "Source-informed exterior reconstruction. Exterior reconstruction with a three-panel solar wing, OCI and polarimeter housings; approximate dimensions. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_pace",
    "modelUrl": "/models/spacecraft/pace.glb",
    "metersPerUnit": 1,
    "boundsM": [
      5,
      3.6387,
      1.9217
    ],
    "parts": [
      "spacecraft_bus",
      "solar_arrays",
      "payload_exterior"
    ],
    "provenance": {
      "source": "https://science.nasa.gov/blogs/pace/2024/02/08/meet-nasas-pace-spacecraft-science-instruments/",
      "credit": "Original Entarian exterior reconstruction from public mission references",
      "usage": "Original geometry; linked photographs are references and are not redistributed in the model"
    },
    "sha256": "ca8a200080efa20f7bfe04db91d7f304645c644e7fc18e304c0011b4cfacfc53",
    "bytes": 39764
  },
  {
    "id": "nisar",
    "label": "NISAR",
    "missionIds": [
      "nisar"
    ],
    "noradIds": [],
    "spanM": 22,
    "sources": [
      "https://www.jpl.nasa.gov/press-kits/nisar/mission-overview/spacecraft/"
    ],
    "pattern": "^NISAR",
    "kind": "reconstruction",
    "note": "Source-informed exterior reconstruction. Public deployed configuration with a 12 m class mesh reflector, boom and two solar wings. Approximate exterior; catalogue NORAD identity still requires separate verification. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_nisar",
    "modelUrl": "/models/spacecraft/nisar.glb",
    "metersPerUnit": 1,
    "boundsM": [
      21.3687,
      22,
      19.4908
    ],
    "parts": [
      "spacecraft_bus",
      "solar_arrays",
      "payload_exterior",
      "radar_boom",
      "radar_reflector"
    ],
    "provenance": {
      "source": "https://www.jpl.nasa.gov/press-kits/nisar/mission-overview/spacecraft/",
      "credit": "Original Entarian exterior reconstruction from public mission references",
      "usage": "Original geometry; linked photographs are references and are not redistributed in the model"
    },
    "sha256": "c9120e736f1e55113825b7164d588c0ed0eda9bcb7bc5502840e2155e79a2d8d",
    "bytes": 103392
  },
  {
    "id": "swot",
    "label": "SWOT",
    "missionIds": [
      "swot"
    ],
    "noradIds": [
      "54757"
    ],
    "spanM": 15,
    "sources": [
      "https://swot.jpl.nasa.gov/mission/spacecraft/"
    ],
    "pattern": "^SWOT",
    "kind": "reconstruction",
    "note": "Source-informed exterior reconstruction. Exterior reconstruction with two KaRIn reflectarrays on a transverse mast; approximate dimensions. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_swot",
    "modelUrl": "/models/spacecraft/swot.glb",
    "metersPerUnit": 1,
    "boundsM": [
      15,
      4.3404,
      12.7273
    ],
    "parts": [
      "spacecraft_bus",
      "solar_arrays",
      "payload_exterior",
      "karin_mast"
    ],
    "provenance": {
      "source": "https://swot.jpl.nasa.gov/mission/spacecraft/",
      "credit": "Original Entarian exterior reconstruction from public mission references",
      "usage": "Original geometry; linked photographs are references and are not redistributed in the model"
    },
    "sha256": "b8c6cb45d89f4a0765937ffe95252020fbc81eefdc0a1609a06574ce68d3c6d2",
    "bytes": 94140
  },
  {
    "id": "gracefo",
    "label": "GRACE Follow-On",
    "missionIds": [
      "gracefo"
    ],
    "noradIds": [],
    "spanM": 3.1,
    "sources": [
      "https://gracefo.jpl.nasa.gov/mission/spacecraft/overview/"
    ],
    "pattern": "^GRACE-FO",
    "kind": "reconstruction",
    "note": "Source-informed exterior reconstruction. Single GRACE-FO spacecraft reference; the mission comprises two vehicles. Solar-covered trapezoidal body reconstructed from public illustrations. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_gracefo",
    "modelUrl": "/models/spacecraft/gracefo.glb",
    "metersPerUnit": 1,
    "boundsM": [
      1.8235,
      1.0321,
      3.1
    ],
    "parts": [
      "spacecraft_bus",
      "solar_arrays",
      "payload_exterior"
    ],
    "provenance": {
      "source": "https://gracefo.jpl.nasa.gov/mission/spacecraft/overview/",
      "credit": "Original Entarian exterior reconstruction from public mission references",
      "usage": "Original geometry; linked photographs are references and are not redistributed in the model"
    },
    "sha256": "ce65dd84969f3beb38cd575ee599ea88ec52b6323a027981a1896d933b34b160",
    "bytes": 11984
  },
  {
    "id": "new_horizons",
    "label": "New Horizons",
    "missionIds": [
      "new_horizons"
    ],
    "noradIds": [],
    "spanM": 3,
    "sources": [
      "https://science.nasa.gov/mission/new-horizons/spacecraft/"
    ],
    "pattern": "^NEW HORIZONS",
    "kind": "reconstruction",
    "note": "Source-informed exterior reconstruction. Exterior reconstruction with high-gain dish and radioisotope generator; approximate instrument layout. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_new_horizons",
    "modelUrl": "/models/spacecraft/new_horizons.glb",
    "metersPerUnit": 1,
    "boundsM": [
      3,
      2.0025,
      2.1616
    ],
    "parts": [
      "spacecraft_bus",
      "payload_exterior",
      "radioisotope_generator"
    ],
    "provenance": {
      "source": "https://science.nasa.gov/mission/new-horizons/spacecraft/",
      "credit": "Original Entarian exterior reconstruction from public mission references",
      "usage": "Original geometry; linked photographs are references and are not redistributed in the model"
    },
    "sha256": "d03e13cc3ad6e0b3b6c193dc304a109c1f76efc0e09cc2c46294dc034b9bd4cc",
    "bytes": 49612
  },
  {
    "id": "raincube",
    "label": "RainCube",
    "missionIds": [
      "raincube"
    ],
    "noradIds": [],
    "spanM": 1,
    "sources": [
      "https://www.jpl.nasa.gov/missions/raincube/"
    ],
    "pattern": "^RAINCUBE",
    "kind": "reconstruction",
    "note": "Source-informed exterior reconstruction. 6U radar CubeSat exterior reconstruction with a deployed reflector. Approximate dimensions. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_raincube",
    "modelUrl": "/models/spacecraft/raincube.glb",
    "metersPerUnit": 1,
    "boundsM": [
      1,
      0.7521,
      0.45
    ],
    "parts": [
      "spacecraft_bus",
      "solar_arrays",
      "payload_exterior"
    ],
    "provenance": {
      "source": "https://www.jpl.nasa.gov/missions/raincube/",
      "credit": "Original Entarian exterior reconstruction from public mission references",
      "usage": "Original geometry; linked photographs are references and are not redistributed in the model"
    },
    "sha256": "4998702995105487c70272f4871e0b96cca152f1ddcc54cb990a5ad415204629",
    "bytes": 86132
  },
  {
    "id": "tropics",
    "label": "TROPICS",
    "missionIds": [
      "tropics"
    ],
    "noradIds": [],
    "spanM": 0.7,
    "sources": [
      "https://tropics.ll.mit.edu/CMS/tropics/"
    ],
    "pattern": "^TROPICS",
    "kind": "reconstruction",
    "note": "Source-informed exterior reconstruction. 3U TROPICS family reconstruction with microwave radiometer and two deployable panels. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_tropics",
    "modelUrl": "/models/spacecraft/tropics.glb",
    "metersPerUnit": 1,
    "boundsM": [
      0.7,
      0.3267,
      0.1633
    ],
    "parts": [
      "spacecraft_bus",
      "solar_arrays",
      "payload_exterior"
    ],
    "provenance": {
      "source": "https://tropics.ll.mit.edu/CMS/tropics/",
      "credit": "Original Entarian exterior reconstruction from public mission references",
      "usage": "Original geometry; linked photographs are references and are not redistributed in the model"
    },
    "sha256": "74c053864a4716c2b75e91e87929e5b3160ad41401dcecf591995c53b65e0417",
    "bytes": 40000
  },
  {
    "id": "mars_express",
    "label": "Mars Express",
    "missionIds": [
      "mars_express"
    ],
    "noradIds": [],
    "spanM": 12,
    "sources": [
      "https://www.esa.int/Science_Exploration/Space_Science/Mars_Express"
    ],
    "pattern": "^MARS EXPRESS",
    "kind": "reconstruction",
    "note": "Source-informed exterior reconstruction. Exterior reconstruction with solar wings, high-gain antenna and MARSIS booms. Approximate presentation scale. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_mars_express",
    "modelUrl": "/models/spacecraft/mars_express.glb",
    "metersPerUnit": 1,
    "boundsM": [
      9.9,
      2.715,
      12
    ],
    "parts": [
      "spacecraft_bus",
      "solar_arrays",
      "payload_exterior",
      "marsis_boom_-1",
      "marsis_boom_1"
    ],
    "provenance": {
      "source": "https://www.esa.int/Science_Exploration/Space_Science/Mars_Express",
      "credit": "Original Entarian exterior reconstruction from public mission references",
      "usage": "Original geometry; linked photographs are references and are not redistributed in the model"
    },
    "sha256": "29502ad1102db612939e8402a01162a17974cca3f8022a4b273f7f58cbf58433",
    "bytes": 58728
  },
  {
    "id": "curiosity",
    "label": "Curiosity rover",
    "missionIds": [
      "curiosity"
    ],
    "noradIds": [],
    "spanM": 3,
    "sources": [
      "https://science.nasa.gov/mission/msl/rover/"
    ],
    "pattern": "^CURIOSITY",
    "kind": "reconstruction",
    "note": "Source-informed exterior reconstruction. Original rover exterior reconstruction with rocker-bogie wheels, mast, sampling arm and RTG. Approximate proportions; not a terrain-localized digital twin. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_curiosity",
    "modelUrl": "/models/spacecraft/curiosity.glb",
    "metersPerUnit": 1,
    "boundsM": [
      3,
      2.16,
      2.2708
    ],
    "parts": [
      "rover_chassis",
      "rocker_bogie_mobility",
      "camera_mast",
      "sampling_arm",
      "radioisotope_generator"
    ],
    "provenance": {
      "source": "https://science.nasa.gov/mission/msl/rover/",
      "credit": "Original Entarian exterior reconstruction from public mission references",
      "usage": "Original geometry; linked photographs are references and are not redistributed in the model"
    },
    "sha256": "23e1565e6ee1ccf08b3431e91cddb7e7b5328a9a9293e4e54cabc9b0de936563",
    "bytes": 125244
  },
  {
    "id": "metop",
    "label": "MetOp first generation",
    "missionIds": [
      "metop_b",
      "metop_c"
    ],
    "noradIds": [
      "38771",
      "43689"
    ],
    "spanM": 17.6,
    "sources": [
      "https://www.esa.int/Applications/Observing_the_Earth/Meteorological_missions/MetOp/About_the_satellite"
    ],
    "pattern": "^METOP-[ABC]",
    "kind": "reconstruction",
    "note": "Source-informed exterior reconstruction. First-generation MetOp reconstruction with payload/service modules, single solar wing and ASCAT antenna booms. Not MetOp-SG. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_metop",
    "modelUrl": "/models/spacecraft/metop.glb",
    "metersPerUnit": 1,
    "boundsM": [
      17.6,
      8.9298,
      6.7196
    ],
    "parts": [
      "spacecraft_bus",
      "solar_arrays",
      "payload_exterior",
      "ascat_boom_-1",
      "ascat_boom_1"
    ],
    "provenance": {
      "source": "https://www.esa.int/Applications/Observing_the_Earth/Meteorological_missions/MetOp/About_the_satellite",
      "credit": "Original Entarian exterior reconstruction from public mission references",
      "usage": "Original geometry; linked photographs are references and are not redistributed in the model"
    },
    "sha256": "26edc3b9359b92978ede49ed2eb7557ea5eb2ba0d94d3fb69a2f0ba4eabac055",
    "bytes": 43836
  },
  {
    "id": "metop_sga",
    "label": "MetOp-SG A",
    "missionIds": [
      "metop_sg_a1"
    ],
    "noradIds": [
      "65159"
    ],
    "spanM": 17,
    "sources": [
      "https://www.esa.int/Applications/Observing_the_Earth/Meteorological_missions/MetOp_Second_Generation"
    ],
    "pattern": "^METOP-SG A",
    "kind": "reconstruction",
    "note": "Source-informed exterior reconstruction. Separate A-type exterior reconstruction with six instrument housings. Approximate housing placement; not a first-generation MetOp substitution. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_metop_sga",
    "modelUrl": "/models/spacecraft/metop_sga.glb",
    "metersPerUnit": 1,
    "boundsM": [
      17,
      8.0206,
      4.9466
    ],
    "parts": [
      "spacecraft_bus",
      "solar_arrays",
      "payload_exterior"
    ],
    "provenance": {
      "source": "https://www.esa.int/Applications/Observing_the_Earth/Meteorological_missions/MetOp_Second_Generation",
      "credit": "Original Entarian exterior reconstruction from public mission references",
      "usage": "Original geometry; linked photographs are references and are not redistributed in the model"
    },
    "sha256": "c52aeb35e7208108a11e58a41b62d2f455d55e91ce5246afc8bb649056a6948e",
    "bytes": 42720
  },
  {
    "id": "paz",
    "label": "PAZ",
    "missionIds": [
      "paz"
    ],
    "noradIds": [
      "43215"
    ],
    "spanM": 5,
    "sources": [
      "https://www.hisdesat.es/en/paz/"
    ],
    "pattern": "^PAZ",
    "kind": "reconstruction",
    "note": "Source-informed exterior reconstruction. PAZ radar spacecraft reconstruction with a long body-mounted SAR antenna and asymmetric solar wing. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_paz",
    "modelUrl": "/models/spacecraft/paz.glb",
    "metersPerUnit": 1,
    "boundsM": [
      5,
      1.9244,
      1.1944
    ],
    "parts": [
      "spacecraft_bus",
      "solar_arrays",
      "payload_exterior"
    ],
    "provenance": {
      "source": "https://www.hisdesat.es/en/paz/",
      "credit": "Original Entarian exterior reconstruction from public mission references",
      "usage": "Original geometry; linked photographs are references and are not redistributed in the model"
    },
    "sha256": "d52a907c18b3a9852733a40fd0a8365824870b4aea440ff22586202f620c229c",
    "bytes": 38092
  },
  {
    "id": "kompsat_optical",
    "label": "KOMPSAT optical family",
    "missionIds": [
      "kompsat2",
      "kompsat3",
      "kompsat3a",
      "kompsat7"
    ],
    "noradIds": [],
    "spanM": 7,
    "sources": [
      "https://www.kari.re.kr/eng/"
    ],
    "pattern": "^KOMPSAT[- ]?(2|3|3A|7)",
    "kind": "reconstruction",
    "note": "Source-informed exterior reconstruction. Representative optical KOMPSAT layout with telescope and paired solar wings. KOMPSAT-2, 3, 3A and 7 differ; this is a family reference, not an exact replica of each generation. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_kompsat_optical",
    "modelUrl": "/models/spacecraft/kompsat_optical.glb",
    "metersPerUnit": 1,
    "boundsM": [
      7,
      1.8852,
      0.9956
    ],
    "parts": [
      "spacecraft_bus",
      "solar_arrays",
      "payload_exterior"
    ],
    "provenance": {
      "source": "https://www.kari.re.kr/eng/",
      "credit": "Original Entarian exterior reconstruction from public mission references",
      "usage": "Original geometry; linked photographs are references and are not redistributed in the model"
    },
    "sha256": "3fb0c47ec436d6dde82d65f0997323b13728305cc7cdcc36fd3b7744f63fad40",
    "bytes": 44908
  },
  {
    "id": "kompsat5",
    "label": "KOMPSAT-5",
    "missionIds": [
      "kompsat5"
    ],
    "noradIds": [
      "39227"
    ],
    "spanM": 9,
    "sources": [
      "https://www.kari.re.kr/eng/"
    ],
    "pattern": "^KOMPSAT[- ]?5",
    "kind": "reconstruction",
    "note": "Source-informed exterior reconstruction. Radar mission reconstruction with a distinct deployed SAR antenna. Approximate exterior geometry. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_kompsat5",
    "modelUrl": "/models/spacecraft/kompsat5.glb",
    "metersPerUnit": 1,
    "boundsM": [
      9,
      1.9773,
      1.2801
    ],
    "parts": [
      "spacecraft_bus",
      "solar_arrays",
      "payload_exterior"
    ],
    "provenance": {
      "source": "https://www.kari.re.kr/eng/",
      "credit": "Original Entarian exterior reconstruction from public mission references",
      "usage": "Original geometry; linked photographs are references and are not redistributed in the model"
    },
    "sha256": "52415e134c38b4d56e2d364451b5fb35c4db1a07a7ecee0ea0afc5fdb52915ab",
    "bytes": 41516
  },
  {
    "id": "geokompsat",
    "label": "GEO-KOMPSAT-2",
    "missionIds": [
      "geo_kompsat_2a",
      "geo_kompsat_2b"
    ],
    "noradIds": [
      "43823",
      "45246"
    ],
    "spanM": 12,
    "sources": [
      "https://www.kari.re.kr/eng/"
    ],
    "pattern": "^GEO[- ]?KOMPSAT",
    "kind": "reconstruction",
    "note": "Source-informed exterior reconstruction. GEO-KOMPSAT-2 bus family reconstruction; 2A meteorology and 2B ocean/environment payload differences are not individually reproduced. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_geokompsat",
    "modelUrl": "/models/spacecraft/geokompsat.glb",
    "metersPerUnit": 1,
    "boundsM": [
      12,
      3.2318,
      1.7068
    ],
    "parts": [
      "spacecraft_bus",
      "solar_arrays",
      "payload_exterior"
    ],
    "provenance": {
      "source": "https://www.kari.re.kr/eng/",
      "credit": "Original Entarian exterior reconstruction from public mission references",
      "usage": "Original geometry; linked photographs are references and are not redistributed in the model"
    },
    "sha256": "f314c00d618127c285eebb2a89a26759371988fc67fc2408c4bf1697ea502cdb",
    "bytes": 44908
  },
  {
    "id": "x37b",
    "label": "X-37B",
    "missionIds": [
      "x37b_otv7"
    ],
    "noradIds": [],
    "spanM": 8.9,
    "sources": [
      "https://www.spaceforce.mil/About-Us/Fact-Sheets/Article/2197743/x-37b-orbital-test-vehicle/"
    ],
    "pattern": "^X-37",
    "kind": "reconstruction",
    "note": "Source-informed exterior reconstruction. Public exterior reconstruction of the reusable spaceplane. Payload bay contents and flight-specific configuration are not represented. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_x37b",
    "modelUrl": "/models/spacecraft/x37b.glb",
    "metersPerUnit": 1,
    "boundsM": [
      8.9,
      2.5445,
      6.6032
    ],
    "parts": [
      "fuselage",
      "wings_and_tail",
      "thermal_protection",
      "payload_bay_doors"
    ],
    "provenance": {
      "source": "https://www.spaceforce.mil/About-Us/Fact-Sheets/Article/2197743/x-37b-orbital-test-vehicle/",
      "credit": "Original Entarian exterior reconstruction from public mission references",
      "usage": "Original geometry; linked photographs are references and are not redistributed in the model"
    },
    "sha256": "a6a88fd14e3d4bc5382cf0367c953607652547f7e8998a1135380a9a5bad30e2",
    "bytes": 11256
  },
  {
    "id": "wsfm",
    "label": "WSF-M",
    "missionIds": [
      "wsf_m"
    ],
    "noradIds": [],
    "spanM": 9,
    "sources": [
      "https://www.baesystems.com/en-us/product/wsf-m"
    ],
    "pattern": "^WSF-M",
    "kind": "reconstruction",
    "note": "Source-informed exterior reconstruction. Public exterior reconstruction with the Microwave Imager reflector and solar wing. Approximate payload placement and presentation scale. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_wsfm",
    "modelUrl": "/models/spacecraft/wsfm.glb",
    "metersPerUnit": 1,
    "boundsM": [
      9,
      6.6723,
      4.8299
    ],
    "parts": [
      "spacecraft_bus",
      "solar_arrays",
      "payload_exterior"
    ],
    "provenance": {
      "source": "https://www.baesystems.com/en-us/product/wsf-m",
      "credit": "Original Entarian exterior reconstruction from public mission references",
      "usage": "Original geometry; linked photographs are references and are not redistributed in the model"
    },
    "sha256": "85832552f62a4a9ed6b42509f659a55b537086ccedbb9c92c8c5b56a4dc0e227",
    "bytes": 52108
  },
  {
    "id": "sensorsat",
    "label": "ORS-5 SensorSat",
    "missionIds": [
      "ors5_sensorssat"
    ],
    "noradIds": [
      "42828"
    ],
    "spanM": 1.5,
    "sources": [
      "https://www.ll.mit.edu/r-d/projects/ors-5-sensorsat"
    ],
    "pattern": "^(ORS-5|SENSORSAT)",
    "kind": "reconstruction",
    "note": "Source-informed exterior reconstruction. Compact optical-surveillance spacecraft reconstructed from public MIT descriptions; approximate exterior and instrument housing. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_sensorsat",
    "modelUrl": "/models/spacecraft/sensorsat.glb",
    "metersPerUnit": 1,
    "boundsM": [
      0.8131,
      1.5,
      0.8201
    ],
    "parts": [
      "spacecraft_bus",
      "solar_arrays",
      "payload_exterior"
    ],
    "provenance": {
      "source": "https://www.ll.mit.edu/r-d/projects/ors-5-sensorsat",
      "credit": "Original Entarian exterior reconstruction from public mission references",
      "usage": "Original geometry; linked photographs are references and are not redistributed in the model"
    },
    "sha256": "fd27f1bc6ec4efb05d8795481e1208c3ddb232b75e1a837b43d501f8c1445302",
    "bytes": 36956
  },
  {
    "id": "sbss",
    "label": "SBSS Block 10",
    "missionIds": [
      "sbss_block10"
    ],
    "noradIds": [
      "37168"
    ],
    "spanM": 5,
    "sources": [
      "https://www.baesystems.com/en/product/sbss"
    ],
    "pattern": "^SBSS",
    "kind": "reconstruction",
    "note": "Source-informed exterior reconstruction. Public exterior reconstruction with an articulated optical payload; nominal pose, approximate dimensions. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_sbss",
    "modelUrl": "/models/spacecraft/sbss.glb",
    "metersPerUnit": 1,
    "boundsM": [
      5,
      2.2125,
      1.25
    ],
    "parts": [
      "spacecraft_bus",
      "solar_arrays",
      "payload_exterior"
    ],
    "provenance": {
      "source": "https://www.baesystems.com/en/product/sbss",
      "credit": "Original Entarian exterior reconstruction from public mission references",
      "usage": "Original geometry; linked photographs are references and are not redistributed in the model"
    },
    "sha256": "a3ea9d8cc3d5fd9c82b1b9894b05bfaff8d0207c0cf524134d3fc93400a2832f",
    "bytes": 39712
  },
  {
    "id": "sapphire",
    "label": "Sapphire",
    "missionIds": [
      "sapphire"
    ],
    "noradIds": [
      "39151"
    ],
    "spanM": 2,
    "sources": [
      "https://www.asc-csa.gc.ca/eng/satellites/sapphire/"
    ],
    "pattern": "^SAPPHIRE",
    "kind": "reconstruction",
    "note": "Source-informed exterior reconstruction. Canadian optical-surveillance mission exterior reference; approximate housing and panel geometry. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_sapphire",
    "modelUrl": "/models/spacecraft/sapphire.glb",
    "metersPerUnit": 1,
    "boundsM": [
      2,
      0.885,
      0.5
    ],
    "parts": [
      "spacecraft_bus",
      "solar_arrays",
      "payload_exterior"
    ],
    "provenance": {
      "source": "https://www.asc-csa.gc.ca/eng/satellites/sapphire/",
      "credit": "Original Entarian exterior reconstruction from public mission references",
      "usage": "Original geometry; linked photographs are references and are not redistributed in the model"
    },
    "sha256": "a686945bc02f5c2d2c6c58fecd066234b242584bc50257e06ceee224998529ec",
    "bytes": 39716
  },
  {
    "id": "viasat3",
    "label": "ViaSat-3",
    "missionIds": [
      "comsatcom_viasat"
    ],
    "noradIds": [],
    "spanM": 45,
    "sources": [
      "https://www.viasat.com/space-innovation/satellite-fleet/viasat-3/"
    ],
    "pattern": "^VIASAT-3",
    "kind": "reconstruction",
    "note": "Source-informed exterior reconstruction. Public ViaSat-3 family layout with large reflectors and solar wings. Exact reflector profile and in-flight deployment condition are not reproduced. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_viasat3",
    "modelUrl": "/models/spacecraft/viasat3.glb",
    "metersPerUnit": 1,
    "boundsM": [
      45,
      17.2105,
      26.172
    ],
    "parts": [
      "spacecraft_bus",
      "solar_arrays",
      "communications_payload"
    ],
    "provenance": {
      "source": "https://www.viasat.com/space-innovation/satellite-fleet/viasat-3/",
      "credit": "Original Entarian exterior reconstruction from public mission references",
      "usage": "Original geometry; linked photographs are references and are not redistributed in the model"
    },
    "sha256": "b215932d82c519aad6c76674292eb1cd4046b6aef10e667c23067aef68d09c4a",
    "bytes": 105620
  },
  {
    "id": "o3bmpower",
    "label": "O3b mPOWER",
    "missionIds": [
      "comsatcom_ses"
    ],
    "noradIds": [],
    "spanM": 20,
    "sources": [
      "https://www.boeing.com/content/dam/boeing/boeingdotcom/space/boeing_satellites/pdf/Bkgd_SatFam_O3bmpower.pdf"
    ],
    "pattern": "^O3B MPOWER",
    "kind": "reconstruction",
    "note": "Source-informed exterior reconstruction. Boeing 702X family exterior reconstruction with phased-array faces. Approximate geometry, not proprietary payload CAD. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_o3bmpower",
    "modelUrl": "/models/spacecraft/o3bmpower.glb",
    "metersPerUnit": 1,
    "boundsM": [
      20,
      3.064,
      2.062
    ],
    "parts": [
      "spacecraft_bus",
      "solar_arrays",
      "communications_payload"
    ],
    "provenance": {
      "source": "https://www.boeing.com/content/dam/boeing/boeingdotcom/space/boeing_satellites/pdf/Bkgd_SatFam_O3bmpower.pdf",
      "credit": "Original Entarian exterior reconstruction from public mission references",
      "usage": "Original geometry; linked photographs are references and are not redistributed in the model"
    },
    "sha256": "d78d988e2c46379a9691b418927bbc723e95b50047aa5b7d09f86141eede48db",
    "bytes": 44120
  },
  {
    "id": "inmarsat6",
    "label": "Inmarsat-6",
    "missionIds": [
      "comsatcom_inmarsat"
    ],
    "noradIds": [],
    "spanM": 40,
    "sources": [
      "https://www.airbus.com/en/products-services/space/telecom-satellites"
    ],
    "pattern": "^INMARSAT 6",
    "kind": "reconstruction",
    "note": "Source-informed exterior reconstruction. Eurostar E3000 family exterior reference with large L-band reflector. This is not evidence of the operational condition or deployed configuration of Inmarsat-6 F2. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_inmarsat6",
    "modelUrl": "/models/spacecraft/inmarsat6.glb",
    "metersPerUnit": 1,
    "boundsM": [
      40,
      14.6486,
      14.464
    ],
    "parts": [
      "spacecraft_bus",
      "solar_arrays",
      "communications_payload"
    ],
    "provenance": {
      "source": "https://www.airbus.com/en/products-services/space/telecom-satellites",
      "credit": "Original Entarian exterior reconstruction from public mission references",
      "usage": "Original geometry; linked photographs are references and are not redistributed in the model"
    },
    "sha256": "a773372f8f4beaf33ee73b40e4d7f7e99e70fa2b27e4d6b964e145813ec6f597",
    "bytes": 95472
  },
  {
    "id": "qzss",
    "label": "QZSS / Michibiki",
    "missionIds": [],
    "noradIds": [],
    "spanM": 19,
    "sources": [
      "https://qzss.go.jp/en/overview/services/sv01.html"
    ],
    "pattern": "^(QZS|MICHIBIKI)",
    "kind": "reconstruction",
    "note": "Source-informed exterior reconstruction. Representative QZSS navigation spacecraft exterior; individual generations and orbit classes differ. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_qzss",
    "modelUrl": "/models/spacecraft/qzss.glb",
    "metersPerUnit": 1,
    "boundsM": [
      19,
      3.7192,
      2.6917
    ],
    "parts": [
      "spacecraft_bus",
      "solar_arrays",
      "payload_exterior"
    ],
    "provenance": {
      "source": "https://qzss.go.jp/en/overview/services/sv01.html",
      "credit": "Original Entarian exterior reconstruction from public mission references",
      "usage": "Original geometry; linked photographs are references and are not redistributed in the model"
    },
    "sha256": "415a5d52c141f5ca49ff8b4408633017dc216fb43c95a0e942e8a829523436ea",
    "bytes": 46888
  },
  {
    "id": "navic",
    "label": "NavIC / IRNSS",
    "missionIds": [],
    "noradIds": [],
    "spanM": 9,
    "sources": [
      "https://www.isro.gov.in/IRNSS_Programme.html"
    ],
    "pattern": "^(IRNSS|NVS-)",
    "kind": "reconstruction",
    "note": "Source-informed exterior reconstruction. IRNSS navigation-bus family reference. Newer NVS vehicles differ; exact generation geometry is not asserted. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_navic",
    "modelUrl": "/models/spacecraft/navic.glb",
    "metersPerUnit": 1,
    "boundsM": [
      9,
      1.7617,
      1.275
    ],
    "parts": [
      "spacecraft_bus",
      "solar_arrays",
      "payload_exterior"
    ],
    "provenance": {
      "source": "https://www.isro.gov.in/IRNSS_Programme.html",
      "credit": "Original Entarian exterior reconstruction from public mission references",
      "usage": "Original geometry; linked photographs are references and are not redistributed in the model"
    },
    "sha256": "e808ca1ca8fa91d9804e862cdf7fae74d7825c5c580a8f5bcf72969e30d74612",
    "bytes": 46888
  },
  {
    "id": "starliner",
    "label": "Starliner",
    "missionIds": [],
    "noradIds": [],
    "spanM": 5,
    "sources": [
      "https://www.boeing.com/space/starliner"
    ],
    "pattern": "^STARLINER",
    "kind": "reconstruction",
    "note": "Source-informed exterior reconstruction. Crew/service module exterior reconstruction. Nominal free-flight configuration; no live docking state. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_starliner",
    "modelUrl": "/models/spacecraft/starliner.glb",
    "metersPerUnit": 1,
    "boundsM": [
      5,
      4.9886,
      5
    ],
    "parts": [
      "service_module",
      "crew_or_cargo_module",
      "solar_arrays",
      "docking_interface"
    ],
    "provenance": {
      "source": "https://www.boeing.com/space/starliner",
      "credit": "Original Entarian exterior reconstruction from public mission references",
      "usage": "Original geometry; linked photographs are references and are not redistributed in the model"
    },
    "sha256": "edb342c4b6a255865c9d7bd221402aefdb9863d4bdf1c21953f67f0916883380",
    "bytes": 9436
  },
  {
    "id": "htv",
    "label": "HTV / Kounotori",
    "missionIds": [],
    "noradIds": [],
    "spanM": 10,
    "sources": [
      "https://humans-in-space.jaxa.jp/en/htv/"
    ],
    "pattern": "^(HTV|KOUNOTORI)",
    "kind": "reconstruction",
    "note": "Source-informed exterior reconstruction. HTV cargo-vehicle exterior reconstruction with cylindrical pressurized/unpressurized sections and body solar panels. HTV-X differences are not reproduced. Presentation scale and nominal pose; not engineering CAD or live attitude/subsystem telemetry.",
    "template": "spacecraft_htv",
    "modelUrl": "/models/spacecraft/htv.glb",
    "metersPerUnit": 1,
    "boundsM": [
      5.0359,
      10,
      4.9036
    ],
    "parts": [
      "service_module",
      "crew_or_cargo_module",
      "solar_arrays",
      "docking_interface",
      "unpressurized_cargo_bay"
    ],
    "provenance": {
      "source": "https://humans-in-space.jaxa.jp/en/htv/",
      "credit": "Original Entarian exterior reconstruction from public mission references",
      "usage": "Original geometry; linked photographs are references and are not redistributed in the model"
    },
    "sha256": "d809c1eb7bc2fa6c5efce8dae9f9d845208bd5335ed284a9581cd0f287a50922",
    "bytes": 10480
  }
]
